var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 265,
    viewBox: "0 0 539 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 71.3324C31.6238 71.6859 31.3372 71.9724 30.9838 71.9724C30.6303 71.9724 30.3438 71.6859 30.3438 71.3324C30.3438 70.9789 30.6303 70.6924 30.9838 70.6924C31.3372 70.6924 31.6238 70.9789 31.6238 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 71.3324C48.2644 71.6859 47.9778 71.9724 47.6244 71.9724C47.271 71.9724 46.9844 71.6859 46.9844 71.3324C46.9844 70.9789 47.271 70.6924 47.6244 70.6924C47.9778 70.6924 48.2644 70.9789 48.2644 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 71.3324C64.9048 71.6859 64.6182 71.9724 64.2648 71.9724C63.9114 71.9724 63.6248 71.6859 63.6248 71.3324C63.6248 70.9789 63.9114 70.6924 64.2648 70.6924C64.6182 70.6924 64.9048 70.9789 64.9048 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 71.3324C81.5454 71.6859 81.2588 71.9724 80.9054 71.9724C80.552 71.9724 80.2654 71.6859 80.2654 71.3324C80.2654 70.9789 80.552 70.6924 80.9054 70.6924C81.2588 70.6924 81.5454 70.9789 81.5454 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 71.3324C98.1858 71.6859 97.8992 71.9724 97.5458 71.9724C97.1924 71.9724 96.9058 71.6859 96.9058 71.3324C96.9058 70.9789 97.1924 70.6924 97.5458 70.6924C97.8992 70.6924 98.1858 70.9789 98.1858 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 71.3324C114.826 71.6859 114.54 71.9724 114.186 71.9724C113.833 71.9724 113.546 71.6859 113.546 71.3324C113.546 70.9789 113.833 70.6924 114.186 70.6924C114.54 70.6924 114.826 70.9789 114.826 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 71.3324C131.467 71.6859 131.18 71.9724 130.827 71.9724C130.474 71.9724 130.187 71.6859 130.187 71.3324C130.187 70.9789 130.474 70.6924 130.827 70.6924C131.18 70.6924 131.467 70.9789 131.467 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 71.3324C148.107 71.6859 147.821 71.9724 147.467 71.9724C147.114 71.9724 146.827 71.6859 146.827 71.3324C146.827 70.9789 147.114 70.6924 147.467 70.6924C147.821 70.6924 148.107 70.9789 148.107 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 71.3324C164.748 71.6859 164.461 71.9724 164.108 71.9724C163.755 71.9724 163.468 71.6859 163.468 71.3324C163.468 70.9789 163.755 70.6924 164.108 70.6924C164.461 70.6924 164.748 70.9789 164.748 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 71.3324C181.388 71.6859 181.102 71.9724 180.748 71.9724C180.395 71.9724 180.108 71.6859 180.108 71.3324C180.108 70.9789 180.395 70.6924 180.748 70.6924C181.102 70.6924 181.388 70.9789 181.388 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 87.973C31.6238 88.3264 31.3372 88.613 30.9838 88.613C30.6303 88.613 30.3438 88.3264 30.3438 87.973C30.3438 87.6196 30.6303 87.333 30.9838 87.333C31.3372 87.333 31.6238 87.6196 31.6238 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 87.973C48.2644 88.3264 47.9778 88.613 47.6244 88.613C47.271 88.613 46.9844 88.3264 46.9844 87.973C46.9844 87.6196 47.271 87.333 47.6244 87.333C47.9778 87.333 48.2644 87.6196 48.2644 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 87.973C64.9048 88.3264 64.6182 88.613 64.2648 88.613C63.9114 88.613 63.6248 88.3264 63.6248 87.973C63.6248 87.6196 63.9114 87.333 64.2648 87.333C64.6182 87.333 64.9048 87.6196 64.9048 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 87.973C81.5454 88.3264 81.2588 88.613 80.9054 88.613C80.552 88.613 80.2654 88.3264 80.2654 87.973C80.2654 87.6196 80.552 87.333 80.9054 87.333C81.2588 87.333 81.5454 87.6196 81.5454 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 87.973C98.1858 88.3264 97.8992 88.613 97.5458 88.613C97.1924 88.613 96.9058 88.3264 96.9058 87.973C96.9058 87.6196 97.1924 87.333 97.5458 87.333C97.8992 87.333 98.1858 87.6196 98.1858 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 87.973C114.826 88.3264 114.54 88.613 114.186 88.613C113.833 88.613 113.546 88.3264 113.546 87.973C113.546 87.6196 113.833 87.333 114.186 87.333C114.54 87.333 114.826 87.6196 114.826 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 87.973C131.467 88.3264 131.18 88.613 130.827 88.613C130.474 88.613 130.187 88.3264 130.187 87.973C130.187 87.6196 130.474 87.333 130.827 87.333C131.18 87.333 131.467 87.6196 131.467 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 87.973C148.107 88.3264 147.821 88.613 147.467 88.613C147.114 88.613 146.827 88.3264 146.827 87.973C146.827 87.6196 147.114 87.333 147.467 87.333C147.821 87.333 148.107 87.6196 148.107 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 87.973C164.748 88.3264 164.461 88.613 164.108 88.613C163.755 88.613 163.468 88.3264 163.468 87.973C163.468 87.6196 163.755 87.333 164.108 87.333C164.461 87.333 164.748 87.6196 164.748 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 87.973C181.388 88.3264 181.102 88.613 180.748 88.613C180.395 88.613 180.108 88.3264 180.108 87.973C180.108 87.6196 180.395 87.333 180.748 87.333C181.102 87.333 181.388 87.6196 181.388 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 104.613C31.6238 104.967 31.3372 105.253 30.9838 105.253C30.6303 105.253 30.3438 104.967 30.3438 104.613C30.3438 104.26 30.6303 103.973 30.9838 103.973C31.3372 103.973 31.6238 104.26 31.6238 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 104.613C48.2644 104.967 47.9778 105.253 47.6244 105.253C47.271 105.253 46.9844 104.967 46.9844 104.613C46.9844 104.26 47.271 103.973 47.6244 103.973C47.9778 103.973 48.2644 104.26 48.2644 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 104.613C64.9048 104.967 64.6182 105.253 64.2648 105.253C63.9114 105.253 63.6248 104.967 63.6248 104.613C63.6248 104.26 63.9114 103.973 64.2648 103.973C64.6182 103.973 64.9048 104.26 64.9048 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 104.613C81.5454 104.967 81.2588 105.253 80.9054 105.253C80.552 105.253 80.2654 104.967 80.2654 104.613C80.2654 104.26 80.552 103.973 80.9054 103.973C81.2588 103.973 81.5454 104.26 81.5454 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 104.613C98.1858 104.967 97.8992 105.253 97.5458 105.253C97.1924 105.253 96.9058 104.967 96.9058 104.613C96.9058 104.26 97.1924 103.973 97.5458 103.973C97.8992 103.973 98.1858 104.26 98.1858 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 104.613C114.826 104.967 114.54 105.253 114.186 105.253C113.833 105.253 113.546 104.967 113.546 104.613C113.546 104.26 113.833 103.973 114.186 103.973C114.54 103.973 114.826 104.26 114.826 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 104.613C131.467 104.967 131.18 105.253 130.827 105.253C130.474 105.253 130.187 104.967 130.187 104.613C130.187 104.26 130.474 103.973 130.827 103.973C131.18 103.973 131.467 104.26 131.467 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 104.613C148.107 104.967 147.821 105.253 147.467 105.253C147.114 105.253 146.827 104.967 146.827 104.613C146.827 104.26 147.114 103.973 147.467 103.973C147.821 103.973 148.107 104.26 148.107 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 104.613C164.748 104.967 164.461 105.253 164.108 105.253C163.755 105.253 163.468 104.967 163.468 104.613C163.468 104.26 163.755 103.973 164.108 103.973C164.461 103.973 164.748 104.26 164.748 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 104.613C181.388 104.967 181.102 105.253 180.748 105.253C180.395 105.253 180.108 104.967 180.108 104.613C180.108 104.26 180.395 103.973 180.748 103.973C181.102 103.973 181.388 104.26 181.388 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 121.254C31.6238 121.607 31.3372 121.894 30.9838 121.894C30.6303 121.894 30.3438 121.607 30.3438 121.254C30.3438 120.901 30.6303 120.614 30.9838 120.614C31.3372 120.614 31.6238 120.901 31.6238 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 121.254C48.2644 121.607 47.9778 121.894 47.6244 121.894C47.271 121.894 46.9844 121.607 46.9844 121.254C46.9844 120.901 47.271 120.614 47.6244 120.614C47.9778 120.614 48.2644 120.901 48.2644 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 121.254C64.9048 121.607 64.6182 121.894 64.2648 121.894C63.9114 121.894 63.6248 121.607 63.6248 121.254C63.6248 120.901 63.9114 120.614 64.2648 120.614C64.6182 120.614 64.9048 120.901 64.9048 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 121.254C81.5454 121.607 81.2588 121.894 80.9054 121.894C80.552 121.894 80.2654 121.607 80.2654 121.254C80.2654 120.901 80.552 120.614 80.9054 120.614C81.2588 120.614 81.5454 120.901 81.5454 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 121.254C98.1858 121.607 97.8992 121.894 97.5458 121.894C97.1924 121.894 96.9058 121.607 96.9058 121.254C96.9058 120.901 97.1924 120.614 97.5458 120.614C97.8992 120.614 98.1858 120.901 98.1858 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 121.254C114.826 121.607 114.54 121.894 114.186 121.894C113.833 121.894 113.546 121.607 113.546 121.254C113.546 120.901 113.833 120.614 114.186 120.614C114.54 120.614 114.826 120.901 114.826 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 121.254C131.467 121.607 131.18 121.894 130.827 121.894C130.474 121.894 130.187 121.607 130.187 121.254C130.187 120.901 130.474 120.614 130.827 120.614C131.18 120.614 131.467 120.901 131.467 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 121.254C148.107 121.607 147.821 121.894 147.467 121.894C147.114 121.894 146.827 121.607 146.827 121.254C146.827 120.901 147.114 120.614 147.467 120.614C147.821 120.614 148.107 120.901 148.107 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 121.254C164.748 121.607 164.461 121.894 164.108 121.894C163.755 121.894 163.468 121.607 163.468 121.254C163.468 120.901 163.755 120.614 164.108 120.614C164.461 120.614 164.748 120.901 164.748 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 121.254C181.388 121.607 181.102 121.894 180.748 121.894C180.395 121.894 180.108 121.607 180.108 121.254C180.108 120.901 180.395 120.614 180.748 120.614C181.102 120.614 181.388 120.901 181.388 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 137.894C31.6238 138.248 31.3372 138.534 30.9838 138.534C30.6303 138.534 30.3438 138.248 30.3438 137.894C30.3438 137.541 30.6303 137.254 30.9838 137.254C31.3372 137.254 31.6238 137.541 31.6238 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 137.894C48.2644 138.248 47.9778 138.534 47.6244 138.534C47.271 138.534 46.9844 138.248 46.9844 137.894C46.9844 137.541 47.271 137.254 47.6244 137.254C47.9778 137.254 48.2644 137.541 48.2644 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 137.894C64.9048 138.248 64.6182 138.534 64.2648 138.534C63.9114 138.534 63.6248 138.248 63.6248 137.894C63.6248 137.541 63.9114 137.254 64.2648 137.254C64.6182 137.254 64.9048 137.541 64.9048 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 137.894C81.5454 138.248 81.2588 138.534 80.9054 138.534C80.552 138.534 80.2654 138.248 80.2654 137.894C80.2654 137.541 80.552 137.254 80.9054 137.254C81.2588 137.254 81.5454 137.541 81.5454 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 137.894C98.1858 138.248 97.8992 138.534 97.5458 138.534C97.1924 138.534 96.9058 138.248 96.9058 137.894C96.9058 137.541 97.1924 137.254 97.5458 137.254C97.8992 137.254 98.1858 137.541 98.1858 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 137.894C114.826 138.248 114.54 138.534 114.186 138.534C113.833 138.534 113.546 138.248 113.546 137.894C113.546 137.541 113.833 137.254 114.186 137.254C114.54 137.254 114.826 137.541 114.826 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 137.894C131.467 138.248 131.18 138.534 130.827 138.534C130.474 138.534 130.187 138.248 130.187 137.894C130.187 137.541 130.474 137.254 130.827 137.254C131.18 137.254 131.467 137.541 131.467 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 137.894C148.107 138.248 147.821 138.534 147.467 138.534C147.114 138.534 146.827 138.248 146.827 137.894C146.827 137.541 147.114 137.254 147.467 137.254C147.821 137.254 148.107 137.541 148.107 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 137.894C164.748 138.248 164.461 138.534 164.108 138.534C163.755 138.534 163.468 138.248 163.468 137.894C163.468 137.541 163.755 137.254 164.108 137.254C164.461 137.254 164.748 137.541 164.748 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 137.894C181.388 138.248 181.102 138.534 180.748 138.534C180.395 138.534 180.108 138.248 180.108 137.894C180.108 137.541 180.395 137.254 180.748 137.254C181.102 137.254 181.388 137.541 181.388 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 154.535C31.6238 154.888 31.3372 155.175 30.9838 155.175C30.6303 155.175 30.3438 154.888 30.3438 154.535C30.3438 154.182 30.6303 153.895 30.9838 153.895C31.3372 153.895 31.6238 154.182 31.6238 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 154.535C48.2644 154.888 47.9778 155.175 47.6244 155.175C47.271 155.175 46.9844 154.888 46.9844 154.535C46.9844 154.182 47.271 153.895 47.6244 153.895C47.9778 153.895 48.2644 154.182 48.2644 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 154.535C64.9048 154.888 64.6182 155.175 64.2648 155.175C63.9114 155.175 63.6248 154.888 63.6248 154.535C63.6248 154.182 63.9114 153.895 64.2648 153.895C64.6182 153.895 64.9048 154.182 64.9048 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 154.535C81.5454 154.888 81.2588 155.175 80.9054 155.175C80.552 155.175 80.2654 154.888 80.2654 154.535C80.2654 154.182 80.552 153.895 80.9054 153.895C81.2588 153.895 81.5454 154.182 81.5454 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 154.535C98.1858 154.888 97.8992 155.175 97.5458 155.175C97.1924 155.175 96.9058 154.888 96.9058 154.535C96.9058 154.182 97.1924 153.895 97.5458 153.895C97.8992 153.895 98.1858 154.182 98.1858 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 154.535C114.826 154.888 114.54 155.175 114.186 155.175C113.833 155.175 113.546 154.888 113.546 154.535C113.546 154.182 113.833 153.895 114.186 153.895C114.54 153.895 114.826 154.182 114.826 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 154.535C131.467 154.888 131.18 155.175 130.827 155.175C130.474 155.175 130.187 154.888 130.187 154.535C130.187 154.182 130.474 153.895 130.827 153.895C131.18 153.895 131.467 154.182 131.467 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 154.535C148.107 154.888 147.821 155.175 147.467 155.175C147.114 155.175 146.827 154.888 146.827 154.535C146.827 154.182 147.114 153.895 147.467 153.895C147.821 153.895 148.107 154.182 148.107 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 154.535C164.748 154.888 164.461 155.175 164.108 155.175C163.755 155.175 163.468 154.888 163.468 154.535C163.468 154.182 163.755 153.895 164.108 153.895C164.461 153.895 164.748 154.182 164.748 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 154.535C181.388 154.888 181.102 155.175 180.748 155.175C180.395 155.175 180.108 154.888 180.108 154.535C180.108 154.182 180.395 153.895 180.748 153.895C181.102 153.895 181.388 154.182 181.388 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 171.176C31.6238 171.529 31.3372 171.816 30.9838 171.816C30.6303 171.816 30.3438 171.529 30.3438 171.176C30.3438 170.822 30.6303 170.536 30.9838 170.536C31.3372 170.536 31.6238 170.822 31.6238 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 171.176C48.2644 171.529 47.9778 171.816 47.6244 171.816C47.271 171.816 46.9844 171.529 46.9844 171.176C46.9844 170.822 47.271 170.536 47.6244 170.536C47.9778 170.536 48.2644 170.822 48.2644 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 171.176C64.9048 171.529 64.6182 171.816 64.2648 171.816C63.9114 171.816 63.6248 171.529 63.6248 171.176C63.6248 170.822 63.9114 170.536 64.2648 170.536C64.6182 170.536 64.9048 170.822 64.9048 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 171.176C81.5454 171.529 81.2588 171.816 80.9054 171.816C80.552 171.816 80.2654 171.529 80.2654 171.176C80.2654 170.822 80.552 170.536 80.9054 170.536C81.2588 170.536 81.5454 170.822 81.5454 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 171.176C98.1858 171.529 97.8992 171.816 97.5458 171.816C97.1924 171.816 96.9058 171.529 96.9058 171.176C96.9058 170.822 97.1924 170.536 97.5458 170.536C97.8992 170.536 98.1858 170.822 98.1858 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 171.176C114.826 171.529 114.54 171.816 114.186 171.816C113.833 171.816 113.546 171.529 113.546 171.176C113.546 170.822 113.833 170.536 114.186 170.536C114.54 170.536 114.826 170.822 114.826 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 171.176C131.467 171.529 131.18 171.816 130.827 171.816C130.474 171.816 130.187 171.529 130.187 171.176C130.187 170.822 130.474 170.536 130.827 170.536C131.18 170.536 131.467 170.822 131.467 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 171.176C148.107 171.529 147.821 171.816 147.467 171.816C147.114 171.816 146.827 171.529 146.827 171.176C146.827 170.822 147.114 170.536 147.467 170.536C147.821 170.536 148.107 170.822 148.107 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 171.176C164.748 171.529 164.461 171.816 164.108 171.816C163.755 171.816 163.468 171.529 163.468 171.176C163.468 170.822 163.755 170.536 164.108 170.536C164.461 170.536 164.748 170.822 164.748 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 171.176C181.388 171.529 181.102 171.816 180.748 171.816C180.395 171.816 180.108 171.529 180.108 171.176C180.108 170.822 180.395 170.536 180.748 170.536C181.102 170.536 181.388 170.822 181.388 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 187.816C31.6238 188.169 31.3372 188.456 30.9838 188.456C30.6303 188.456 30.3438 188.169 30.3438 187.816C30.3438 187.463 30.6303 187.176 30.9838 187.176C31.3372 187.176 31.6238 187.463 31.6238 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 187.816C48.2644 188.169 47.9778 188.456 47.6244 188.456C47.271 188.456 46.9844 188.169 46.9844 187.816C46.9844 187.463 47.271 187.176 47.6244 187.176C47.9778 187.176 48.2644 187.463 48.2644 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 187.816C64.9048 188.169 64.6182 188.456 64.2648 188.456C63.9114 188.456 63.6248 188.169 63.6248 187.816C63.6248 187.463 63.9114 187.176 64.2648 187.176C64.6182 187.176 64.9048 187.463 64.9048 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 187.816C81.5454 188.169 81.2588 188.456 80.9054 188.456C80.552 188.456 80.2654 188.169 80.2654 187.816C80.2654 187.463 80.552 187.176 80.9054 187.176C81.2588 187.176 81.5454 187.463 81.5454 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 187.816C98.1858 188.169 97.8992 188.456 97.5458 188.456C97.1924 188.456 96.9058 188.169 96.9058 187.816C96.9058 187.463 97.1924 187.176 97.5458 187.176C97.8992 187.176 98.1858 187.463 98.1858 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 187.816C114.826 188.169 114.54 188.456 114.186 188.456C113.833 188.456 113.546 188.169 113.546 187.816C113.546 187.463 113.833 187.176 114.186 187.176C114.54 187.176 114.826 187.463 114.826 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 187.816C131.467 188.169 131.18 188.456 130.827 188.456C130.474 188.456 130.187 188.169 130.187 187.816C130.187 187.463 130.474 187.176 130.827 187.176C131.18 187.176 131.467 187.463 131.467 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 187.816C148.107 188.169 147.821 188.456 147.467 188.456C147.114 188.456 146.827 188.169 146.827 187.816C146.827 187.463 147.114 187.176 147.467 187.176C147.821 187.176 148.107 187.463 148.107 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 187.816C164.748 188.169 164.461 188.456 164.108 188.456C163.755 188.456 163.468 188.169 163.468 187.816C163.468 187.463 163.755 187.176 164.108 187.176C164.461 187.176 164.748 187.463 164.748 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 187.816C181.388 188.169 181.102 188.456 180.748 188.456C180.395 188.456 180.108 188.169 180.108 187.816C180.108 187.463 180.395 187.176 180.748 187.176C181.102 187.176 181.388 187.463 181.388 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 204.457C31.6238 204.81 31.3372 205.097 30.9838 205.097C30.6303 205.097 30.3438 204.81 30.3438 204.457C30.3438 204.103 30.6303 203.817 30.9838 203.817C31.3372 203.817 31.6238 204.103 31.6238 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 204.457C48.2644 204.81 47.9778 205.097 47.6244 205.097C47.271 205.097 46.9844 204.81 46.9844 204.457C46.9844 204.103 47.271 203.817 47.6244 203.817C47.9778 203.817 48.2644 204.103 48.2644 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 204.457C64.9048 204.81 64.6182 205.097 64.2648 205.097C63.9114 205.097 63.6248 204.81 63.6248 204.457C63.6248 204.103 63.9114 203.817 64.2648 203.817C64.6182 203.817 64.9048 204.103 64.9048 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 204.457C81.5454 204.81 81.2588 205.097 80.9054 205.097C80.552 205.097 80.2654 204.81 80.2654 204.457C80.2654 204.103 80.552 203.817 80.9054 203.817C81.2588 203.817 81.5454 204.103 81.5454 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 204.457C98.1858 204.81 97.8992 205.097 97.5458 205.097C97.1924 205.097 96.9058 204.81 96.9058 204.457C96.9058 204.103 97.1924 203.817 97.5458 203.817C97.8992 203.817 98.1858 204.103 98.1858 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 204.457C114.826 204.81 114.54 205.097 114.186 205.097C113.833 205.097 113.546 204.81 113.546 204.457C113.546 204.103 113.833 203.817 114.186 203.817C114.54 203.817 114.826 204.103 114.826 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 204.457C131.467 204.81 131.18 205.097 130.827 205.097C130.474 205.097 130.187 204.81 130.187 204.457C130.187 204.103 130.474 203.817 130.827 203.817C131.18 203.817 131.467 204.103 131.467 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 204.457C148.107 204.81 147.821 205.097 147.467 205.097C147.114 205.097 146.827 204.81 146.827 204.457C146.827 204.103 147.114 203.817 147.467 203.817C147.821 203.817 148.107 204.103 148.107 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 204.457C164.748 204.81 164.461 205.097 164.108 205.097C163.755 205.097 163.468 204.81 163.468 204.457C163.468 204.103 163.755 203.817 164.108 203.817C164.461 203.817 164.748 204.103 164.748 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 204.457C181.388 204.81 181.102 205.097 180.748 205.097C180.395 205.097 180.108 204.81 180.108 204.457C180.108 204.103 180.395 203.817 180.748 203.817C181.102 203.817 181.388 204.103 181.388 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 221.097C31.6238 221.45 31.3372 221.737 30.9838 221.737C30.6303 221.737 30.3438 221.45 30.3438 221.097C30.3438 220.744 30.6303 220.457 30.9838 220.457C31.3372 220.457 31.6238 220.744 31.6238 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 221.097C48.2644 221.45 47.9778 221.737 47.6244 221.737C47.271 221.737 46.9844 221.45 46.9844 221.097C46.9844 220.744 47.271 220.457 47.6244 220.457C47.9778 220.457 48.2644 220.744 48.2644 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 221.097C64.9048 221.45 64.6182 221.737 64.2648 221.737C63.9114 221.737 63.6248 221.45 63.6248 221.097C63.6248 220.744 63.9114 220.457 64.2648 220.457C64.6182 220.457 64.9048 220.744 64.9048 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 221.097C81.5454 221.45 81.2588 221.737 80.9054 221.737C80.552 221.737 80.2654 221.45 80.2654 221.097C80.2654 220.744 80.552 220.457 80.9054 220.457C81.2588 220.457 81.5454 220.744 81.5454 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 221.097C98.1858 221.45 97.8992 221.737 97.5458 221.737C97.1924 221.737 96.9058 221.45 96.9058 221.097C96.9058 220.744 97.1924 220.457 97.5458 220.457C97.8992 220.457 98.1858 220.744 98.1858 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 221.097C114.826 221.45 114.54 221.737 114.186 221.737C113.833 221.737 113.546 221.45 113.546 221.097C113.546 220.744 113.833 220.457 114.186 220.457C114.54 220.457 114.826 220.744 114.826 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 221.097C131.467 221.45 131.18 221.737 130.827 221.737C130.474 221.737 130.187 221.45 130.187 221.097C130.187 220.744 130.474 220.457 130.827 220.457C131.18 220.457 131.467 220.744 131.467 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 221.097C148.107 221.45 147.821 221.737 147.467 221.737C147.114 221.737 146.827 221.45 146.827 221.097C146.827 220.744 147.114 220.457 147.467 220.457C147.821 220.457 148.107 220.744 148.107 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 221.097C164.748 221.45 164.461 221.737 164.108 221.737C163.755 221.737 163.468 221.45 163.468 221.097C163.468 220.744 163.755 220.457 164.108 220.457C164.461 220.457 164.748 220.744 164.748 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 221.097C181.388 221.45 181.102 221.737 180.748 221.737C180.395 221.737 180.108 221.45 180.108 221.097C180.108 220.744 180.395 220.457 180.748 220.457C181.102 220.457 181.388 220.744 181.388 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 237.738C31.6238 238.091 31.3372 238.378 30.9838 238.378C30.6303 238.378 30.3438 238.091 30.3438 237.738C30.3438 237.384 30.6303 237.098 30.9838 237.098C31.3372 237.098 31.6238 237.384 31.6238 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 237.738C48.2644 238.091 47.9778 238.378 47.6244 238.378C47.271 238.378 46.9844 238.091 46.9844 237.738C46.9844 237.384 47.271 237.098 47.6244 237.098C47.9778 237.098 48.2644 237.384 48.2644 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 237.738C64.9048 238.091 64.6182 238.378 64.2648 238.378C63.9114 238.378 63.6248 238.091 63.6248 237.738C63.6248 237.384 63.9114 237.098 64.2648 237.098C64.6182 237.098 64.9048 237.384 64.9048 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 237.738C81.5454 238.091 81.2588 238.378 80.9054 238.378C80.552 238.378 80.2654 238.091 80.2654 237.738C80.2654 237.384 80.552 237.098 80.9054 237.098C81.2588 237.098 81.5454 237.384 81.5454 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 237.738C98.1858 238.091 97.8992 238.378 97.5458 238.378C97.1924 238.378 96.9058 238.091 96.9058 237.738C96.9058 237.384 97.1924 237.098 97.5458 237.098C97.8992 237.098 98.1858 237.384 98.1858 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 237.738C114.826 238.091 114.54 238.378 114.186 238.378C113.833 238.378 113.546 238.091 113.546 237.738C113.546 237.384 113.833 237.098 114.186 237.098C114.54 237.098 114.826 237.384 114.826 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 237.738C131.467 238.091 131.18 238.378 130.827 238.378C130.474 238.378 130.187 238.091 130.187 237.738C130.187 237.384 130.474 237.098 130.827 237.098C131.18 237.098 131.467 237.384 131.467 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 237.738C148.107 238.091 147.821 238.378 147.467 238.378C147.114 238.378 146.827 238.091 146.827 237.738C146.827 237.384 147.114 237.098 147.467 237.098C147.821 237.098 148.107 237.384 148.107 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 237.738C164.748 238.091 164.461 238.378 164.108 238.378C163.755 238.378 163.468 238.091 163.468 237.738C163.468 237.384 163.755 237.098 164.108 237.098C164.461 237.098 164.748 237.384 164.748 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 237.738C181.388 238.091 181.102 238.378 180.748 238.378C180.395 238.378 180.108 238.091 180.108 237.738C180.108 237.384 180.395 237.098 180.748 237.098C181.102 237.098 181.388 237.384 181.388 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6238 254.378C31.6238 254.732 31.3372 255.018 30.9838 255.018C30.6303 255.018 30.3438 254.732 30.3438 254.378C30.3438 254.025 30.6303 253.738 30.9838 253.738C31.3372 253.738 31.6238 254.025 31.6238 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2644 254.378C48.2644 254.732 47.9778 255.018 47.6244 255.018C47.271 255.018 46.9844 254.732 46.9844 254.378C46.9844 254.025 47.271 253.738 47.6244 253.738C47.9778 253.738 48.2644 254.025 48.2644 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9048 254.378C64.9048 254.732 64.6182 255.018 64.2648 255.018C63.9114 255.018 63.6248 254.732 63.6248 254.378C63.6248 254.025 63.9114 253.738 64.2648 253.738C64.6182 253.738 64.9048 254.025 64.9048 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5454 254.378C81.5454 254.732 81.2588 255.018 80.9054 255.018C80.552 255.018 80.2654 254.732 80.2654 254.378C80.2654 254.025 80.552 253.738 80.9054 253.738C81.2588 253.738 81.5454 254.025 81.5454 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1858 254.378C98.1858 254.732 97.8992 255.018 97.5458 255.018C97.1924 255.018 96.9058 254.732 96.9058 254.378C96.9058 254.025 97.1924 253.738 97.5458 253.738C97.8992 253.738 98.1858 254.025 98.1858 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.826 254.378C114.826 254.732 114.54 255.018 114.186 255.018C113.833 255.018 113.546 254.732 113.546 254.378C113.546 254.025 113.833 253.738 114.186 253.738C114.54 253.738 114.826 254.025 114.826 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.467 254.378C131.467 254.732 131.18 255.018 130.827 255.018C130.474 255.018 130.187 254.732 130.187 254.378C130.187 254.025 130.474 253.738 130.827 253.738C131.18 253.738 131.467 254.025 131.467 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.107 254.378C148.107 254.732 147.821 255.018 147.467 255.018C147.114 255.018 146.827 254.732 146.827 254.378C146.827 254.025 147.114 253.738 147.467 253.738C147.821 253.738 148.107 254.025 148.107 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.748 254.378C164.748 254.732 164.461 255.018 164.108 255.018C163.755 255.018 163.468 254.732 163.468 254.378C163.468 254.025 163.755 253.738 164.108 253.738C164.461 253.738 164.748 254.025 164.748 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 254.378C181.388 254.732 181.102 255.018 180.748 255.018C180.395 255.018 180.108 254.732 180.108 254.378C180.108 254.025 180.395 253.738 180.748 253.738C181.102 253.738 181.388 254.025 181.388 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 71.3324C346.514 71.6859 346.8 71.9724 347.154 71.9724C347.507 71.9724 347.794 71.6859 347.794 71.3324C347.794 70.9789 347.507 70.6924 347.154 70.6924C346.8 70.6924 346.514 70.9789 346.514 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 71.3324C329.873 71.6859 330.16 71.9724 330.513 71.9724C330.867 71.9724 331.153 71.6859 331.153 71.3324C331.153 70.9789 330.867 70.6924 330.513 70.6924C330.16 70.6924 329.873 70.9789 329.873 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 71.3324C313.233 71.6859 313.519 71.9724 313.873 71.9724C314.226 71.9724 314.513 71.6859 314.513 71.3324C314.513 70.9789 314.226 70.6924 313.873 70.6924C313.519 70.6924 313.233 70.9789 313.233 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 71.3324C296.592 71.6859 296.879 71.9724 297.232 71.9724C297.586 71.9724 297.872 71.6859 297.872 71.3324C297.872 70.9789 297.586 70.6924 297.232 70.6924C296.879 70.6924 296.592 70.9789 296.592 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 71.3324C279.952 71.6859 280.238 71.9724 280.592 71.9724C280.945 71.9724 281.232 71.6859 281.232 71.3324C281.232 70.9789 280.945 70.6924 280.592 70.6924C280.238 70.6924 279.952 70.9789 279.952 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 71.3324C263.311 71.6859 263.598 71.9724 263.951 71.9724C264.304 71.9724 264.591 71.6859 264.591 71.3324C264.591 70.9789 264.304 70.6924 263.951 70.6924C263.598 70.6924 263.311 70.9789 263.311 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 71.3324C246.671 71.6859 246.957 71.9724 247.311 71.9724C247.664 71.9724 247.951 71.6859 247.951 71.3324C247.951 70.9789 247.664 70.6924 247.311 70.6924C246.957 70.6924 246.671 70.9789 246.671 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 71.3324C230.03 71.6859 230.317 71.9724 230.67 71.9724C231.023 71.9724 231.31 71.6859 231.31 71.3324C231.31 70.9789 231.023 70.6924 230.67 70.6924C230.317 70.6924 230.03 70.9789 230.03 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 71.3324C213.39 71.6859 213.676 71.9724 214.03 71.9724C214.383 71.9724 214.67 71.6859 214.67 71.3324C214.67 70.9789 214.383 70.6924 214.03 70.6924C213.676 70.6924 213.39 70.9789 213.39 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 71.3324C196.749 71.6859 197.036 71.9724 197.389 71.9724C197.742 71.9724 198.029 71.6859 198.029 71.3324C198.029 70.9789 197.742 70.6924 197.389 70.6924C197.036 70.6924 196.749 70.9789 196.749 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 87.973C346.514 88.3264 346.8 88.613 347.154 88.613C347.507 88.613 347.794 88.3264 347.794 87.973C347.794 87.6196 347.507 87.333 347.154 87.333C346.8 87.333 346.514 87.6196 346.514 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 87.973C329.873 88.3264 330.16 88.613 330.513 88.613C330.867 88.613 331.153 88.3264 331.153 87.973C331.153 87.6196 330.867 87.333 330.513 87.333C330.16 87.333 329.873 87.6196 329.873 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 87.973C313.233 88.3264 313.519 88.613 313.873 88.613C314.226 88.613 314.513 88.3264 314.513 87.973C314.513 87.6196 314.226 87.333 313.873 87.333C313.519 87.333 313.233 87.6196 313.233 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 87.973C296.592 88.3264 296.879 88.613 297.232 88.613C297.586 88.613 297.872 88.3264 297.872 87.973C297.872 87.6196 297.586 87.333 297.232 87.333C296.879 87.333 296.592 87.6196 296.592 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 87.973C279.952 88.3264 280.238 88.613 280.592 88.613C280.945 88.613 281.232 88.3264 281.232 87.973C281.232 87.6196 280.945 87.333 280.592 87.333C280.238 87.333 279.952 87.6196 279.952 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 87.973C263.311 88.3264 263.598 88.613 263.951 88.613C264.304 88.613 264.591 88.3264 264.591 87.973C264.591 87.6196 264.304 87.333 263.951 87.333C263.598 87.333 263.311 87.6196 263.311 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 87.973C246.671 88.3264 246.957 88.613 247.311 88.613C247.664 88.613 247.951 88.3264 247.951 87.973C247.951 87.6196 247.664 87.333 247.311 87.333C246.957 87.333 246.671 87.6196 246.671 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 87.973C230.03 88.3264 230.317 88.613 230.67 88.613C231.023 88.613 231.31 88.3264 231.31 87.973C231.31 87.6196 231.023 87.333 230.67 87.333C230.317 87.333 230.03 87.6196 230.03 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 87.973C213.39 88.3264 213.676 88.613 214.03 88.613C214.383 88.613 214.67 88.3264 214.67 87.973C214.67 87.6196 214.383 87.333 214.03 87.333C213.676 87.333 213.39 87.6196 213.39 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 87.973C196.749 88.3264 197.036 88.613 197.389 88.613C197.742 88.613 198.029 88.3264 198.029 87.973C198.029 87.6196 197.742 87.333 197.389 87.333C197.036 87.333 196.749 87.6196 196.749 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 104.613C346.514 104.967 346.8 105.253 347.154 105.253C347.507 105.253 347.794 104.967 347.794 104.613C347.794 104.26 347.507 103.973 347.154 103.973C346.8 103.973 346.514 104.26 346.514 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 104.613C329.873 104.967 330.16 105.253 330.513 105.253C330.867 105.253 331.153 104.967 331.153 104.613C331.153 104.26 330.867 103.973 330.513 103.973C330.16 103.973 329.873 104.26 329.873 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 104.613C313.233 104.967 313.519 105.253 313.873 105.253C314.226 105.253 314.513 104.967 314.513 104.613C314.513 104.26 314.226 103.973 313.873 103.973C313.519 103.973 313.233 104.26 313.233 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 104.613C296.592 104.967 296.879 105.253 297.232 105.253C297.586 105.253 297.872 104.967 297.872 104.613C297.872 104.26 297.586 103.973 297.232 103.973C296.879 103.973 296.592 104.26 296.592 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 104.613C279.952 104.967 280.238 105.253 280.592 105.253C280.945 105.253 281.232 104.967 281.232 104.613C281.232 104.26 280.945 103.973 280.592 103.973C280.238 103.973 279.952 104.26 279.952 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 104.613C263.311 104.967 263.598 105.253 263.951 105.253C264.304 105.253 264.591 104.967 264.591 104.613C264.591 104.26 264.304 103.973 263.951 103.973C263.598 103.973 263.311 104.26 263.311 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 104.613C246.671 104.967 246.957 105.253 247.311 105.253C247.664 105.253 247.951 104.967 247.951 104.613C247.951 104.26 247.664 103.973 247.311 103.973C246.957 103.973 246.671 104.26 246.671 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 104.613C230.03 104.967 230.317 105.253 230.67 105.253C231.023 105.253 231.31 104.967 231.31 104.613C231.31 104.26 231.023 103.973 230.67 103.973C230.317 103.973 230.03 104.26 230.03 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 104.613C213.39 104.967 213.676 105.253 214.03 105.253C214.383 105.253 214.67 104.967 214.67 104.613C214.67 104.26 214.383 103.973 214.03 103.973C213.676 103.973 213.39 104.26 213.39 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 104.613C196.749 104.967 197.036 105.253 197.389 105.253C197.742 105.253 198.029 104.967 198.029 104.613C198.029 104.26 197.742 103.973 197.389 103.973C197.036 103.973 196.749 104.26 196.749 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 121.254C346.514 121.607 346.8 121.894 347.154 121.894C347.507 121.894 347.794 121.607 347.794 121.254C347.794 120.901 347.507 120.614 347.154 120.614C346.8 120.614 346.514 120.901 346.514 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 121.254C329.873 121.607 330.16 121.894 330.513 121.894C330.867 121.894 331.153 121.607 331.153 121.254C331.153 120.901 330.867 120.614 330.513 120.614C330.16 120.614 329.873 120.901 329.873 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 121.254C313.233 121.607 313.519 121.894 313.873 121.894C314.226 121.894 314.513 121.607 314.513 121.254C314.513 120.901 314.226 120.614 313.873 120.614C313.519 120.614 313.233 120.901 313.233 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 121.254C296.592 121.607 296.879 121.894 297.232 121.894C297.586 121.894 297.872 121.607 297.872 121.254C297.872 120.901 297.586 120.614 297.232 120.614C296.879 120.614 296.592 120.901 296.592 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 121.254C279.952 121.607 280.238 121.894 280.592 121.894C280.945 121.894 281.232 121.607 281.232 121.254C281.232 120.901 280.945 120.614 280.592 120.614C280.238 120.614 279.952 120.901 279.952 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 121.254C263.311 121.607 263.598 121.894 263.951 121.894C264.304 121.894 264.591 121.607 264.591 121.254C264.591 120.901 264.304 120.614 263.951 120.614C263.598 120.614 263.311 120.901 263.311 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 121.254C246.671 121.607 246.957 121.894 247.311 121.894C247.664 121.894 247.951 121.607 247.951 121.254C247.951 120.901 247.664 120.614 247.311 120.614C246.957 120.614 246.671 120.901 246.671 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 121.254C230.03 121.607 230.317 121.894 230.67 121.894C231.023 121.894 231.31 121.607 231.31 121.254C231.31 120.901 231.023 120.614 230.67 120.614C230.317 120.614 230.03 120.901 230.03 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 121.254C213.39 121.607 213.676 121.894 214.03 121.894C214.383 121.894 214.67 121.607 214.67 121.254C214.67 120.901 214.383 120.614 214.03 120.614C213.676 120.614 213.39 120.901 213.39 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 121.254C196.749 121.607 197.036 121.894 197.389 121.894C197.742 121.894 198.029 121.607 198.029 121.254C198.029 120.901 197.742 120.614 197.389 120.614C197.036 120.614 196.749 120.901 196.749 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 137.894C346.514 138.248 346.8 138.534 347.154 138.534C347.507 138.534 347.794 138.248 347.794 137.894C347.794 137.541 347.507 137.254 347.154 137.254C346.8 137.254 346.514 137.541 346.514 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 137.894C329.873 138.248 330.16 138.534 330.513 138.534C330.867 138.534 331.153 138.248 331.153 137.894C331.153 137.541 330.867 137.254 330.513 137.254C330.16 137.254 329.873 137.541 329.873 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 137.894C313.233 138.248 313.519 138.534 313.873 138.534C314.226 138.534 314.513 138.248 314.513 137.894C314.513 137.541 314.226 137.254 313.873 137.254C313.519 137.254 313.233 137.541 313.233 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 137.894C296.592 138.248 296.879 138.534 297.232 138.534C297.586 138.534 297.872 138.248 297.872 137.894C297.872 137.541 297.586 137.254 297.232 137.254C296.879 137.254 296.592 137.541 296.592 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 137.894C279.952 138.248 280.238 138.534 280.592 138.534C280.945 138.534 281.232 138.248 281.232 137.894C281.232 137.541 280.945 137.254 280.592 137.254C280.238 137.254 279.952 137.541 279.952 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 137.894C263.311 138.248 263.598 138.534 263.951 138.534C264.304 138.534 264.591 138.248 264.591 137.894C264.591 137.541 264.304 137.254 263.951 137.254C263.598 137.254 263.311 137.541 263.311 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 137.894C246.671 138.248 246.957 138.534 247.311 138.534C247.664 138.534 247.951 138.248 247.951 137.894C247.951 137.541 247.664 137.254 247.311 137.254C246.957 137.254 246.671 137.541 246.671 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 137.894C230.03 138.248 230.317 138.534 230.67 138.534C231.023 138.534 231.31 138.248 231.31 137.894C231.31 137.541 231.023 137.254 230.67 137.254C230.317 137.254 230.03 137.541 230.03 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 137.894C213.39 138.248 213.676 138.534 214.03 138.534C214.383 138.534 214.67 138.248 214.67 137.894C214.67 137.541 214.383 137.254 214.03 137.254C213.676 137.254 213.39 137.541 213.39 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 137.894C196.749 138.248 197.036 138.534 197.389 138.534C197.742 138.534 198.029 138.248 198.029 137.894C198.029 137.541 197.742 137.254 197.389 137.254C197.036 137.254 196.749 137.541 196.749 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 154.535C346.514 154.888 346.8 155.175 347.154 155.175C347.507 155.175 347.794 154.888 347.794 154.535C347.794 154.182 347.507 153.895 347.154 153.895C346.8 153.895 346.514 154.182 346.514 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 154.535C329.873 154.888 330.16 155.175 330.513 155.175C330.867 155.175 331.153 154.888 331.153 154.535C331.153 154.182 330.867 153.895 330.513 153.895C330.16 153.895 329.873 154.182 329.873 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 154.535C313.233 154.888 313.519 155.175 313.873 155.175C314.226 155.175 314.513 154.888 314.513 154.535C314.513 154.182 314.226 153.895 313.873 153.895C313.519 153.895 313.233 154.182 313.233 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 154.535C296.592 154.888 296.879 155.175 297.232 155.175C297.586 155.175 297.872 154.888 297.872 154.535C297.872 154.182 297.586 153.895 297.232 153.895C296.879 153.895 296.592 154.182 296.592 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 154.535C279.952 154.888 280.238 155.175 280.592 155.175C280.945 155.175 281.232 154.888 281.232 154.535C281.232 154.182 280.945 153.895 280.592 153.895C280.238 153.895 279.952 154.182 279.952 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 154.535C263.311 154.888 263.598 155.175 263.951 155.175C264.304 155.175 264.591 154.888 264.591 154.535C264.591 154.182 264.304 153.895 263.951 153.895C263.598 153.895 263.311 154.182 263.311 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 154.535C246.671 154.888 246.957 155.175 247.311 155.175C247.664 155.175 247.951 154.888 247.951 154.535C247.951 154.182 247.664 153.895 247.311 153.895C246.957 153.895 246.671 154.182 246.671 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 154.535C230.03 154.888 230.317 155.175 230.67 155.175C231.023 155.175 231.31 154.888 231.31 154.535C231.31 154.182 231.023 153.895 230.67 153.895C230.317 153.895 230.03 154.182 230.03 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 154.535C213.39 154.888 213.676 155.175 214.03 155.175C214.383 155.175 214.67 154.888 214.67 154.535C214.67 154.182 214.383 153.895 214.03 153.895C213.676 153.895 213.39 154.182 213.39 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 154.535C196.749 154.888 197.036 155.175 197.389 155.175C197.742 155.175 198.029 154.888 198.029 154.535C198.029 154.182 197.742 153.895 197.389 153.895C197.036 153.895 196.749 154.182 196.749 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 171.176C346.514 171.529 346.8 171.816 347.154 171.816C347.507 171.816 347.794 171.529 347.794 171.176C347.794 170.822 347.507 170.536 347.154 170.536C346.8 170.536 346.514 170.822 346.514 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 171.176C329.873 171.529 330.16 171.816 330.513 171.816C330.867 171.816 331.153 171.529 331.153 171.176C331.153 170.822 330.867 170.536 330.513 170.536C330.16 170.536 329.873 170.822 329.873 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 171.176C313.233 171.529 313.519 171.816 313.873 171.816C314.226 171.816 314.513 171.529 314.513 171.176C314.513 170.822 314.226 170.536 313.873 170.536C313.519 170.536 313.233 170.822 313.233 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 171.176C296.592 171.529 296.879 171.816 297.232 171.816C297.586 171.816 297.872 171.529 297.872 171.176C297.872 170.822 297.586 170.536 297.232 170.536C296.879 170.536 296.592 170.822 296.592 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 171.176C279.952 171.529 280.238 171.816 280.592 171.816C280.945 171.816 281.232 171.529 281.232 171.176C281.232 170.822 280.945 170.536 280.592 170.536C280.238 170.536 279.952 170.822 279.952 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 171.176C263.311 171.529 263.598 171.816 263.951 171.816C264.304 171.816 264.591 171.529 264.591 171.176C264.591 170.822 264.304 170.536 263.951 170.536C263.598 170.536 263.311 170.822 263.311 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 171.176C246.671 171.529 246.957 171.816 247.311 171.816C247.664 171.816 247.951 171.529 247.951 171.176C247.951 170.822 247.664 170.536 247.311 170.536C246.957 170.536 246.671 170.822 246.671 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 171.176C230.03 171.529 230.317 171.816 230.67 171.816C231.023 171.816 231.31 171.529 231.31 171.176C231.31 170.822 231.023 170.536 230.67 170.536C230.317 170.536 230.03 170.822 230.03 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 171.176C213.39 171.529 213.676 171.816 214.03 171.816C214.383 171.816 214.67 171.529 214.67 171.176C214.67 170.822 214.383 170.536 214.03 170.536C213.676 170.536 213.39 170.822 213.39 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 171.176C196.749 171.529 197.036 171.816 197.389 171.816C197.742 171.816 198.029 171.529 198.029 171.176C198.029 170.822 197.742 170.536 197.389 170.536C197.036 170.536 196.749 170.822 196.749 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 187.816C346.514 188.169 346.8 188.456 347.154 188.456C347.507 188.456 347.794 188.169 347.794 187.816C347.794 187.463 347.507 187.176 347.154 187.176C346.8 187.176 346.514 187.463 346.514 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 187.816C329.873 188.169 330.16 188.456 330.513 188.456C330.867 188.456 331.153 188.169 331.153 187.816C331.153 187.463 330.867 187.176 330.513 187.176C330.16 187.176 329.873 187.463 329.873 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 187.816C313.233 188.169 313.519 188.456 313.873 188.456C314.226 188.456 314.513 188.169 314.513 187.816C314.513 187.463 314.226 187.176 313.873 187.176C313.519 187.176 313.233 187.463 313.233 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 187.816C296.592 188.169 296.879 188.456 297.232 188.456C297.586 188.456 297.872 188.169 297.872 187.816C297.872 187.463 297.586 187.176 297.232 187.176C296.879 187.176 296.592 187.463 296.592 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 187.816C279.952 188.169 280.238 188.456 280.592 188.456C280.945 188.456 281.232 188.169 281.232 187.816C281.232 187.463 280.945 187.176 280.592 187.176C280.238 187.176 279.952 187.463 279.952 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 187.816C263.311 188.169 263.598 188.456 263.951 188.456C264.304 188.456 264.591 188.169 264.591 187.816C264.591 187.463 264.304 187.176 263.951 187.176C263.598 187.176 263.311 187.463 263.311 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 187.816C246.671 188.169 246.957 188.456 247.311 188.456C247.664 188.456 247.951 188.169 247.951 187.816C247.951 187.463 247.664 187.176 247.311 187.176C246.957 187.176 246.671 187.463 246.671 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 187.816C230.03 188.169 230.317 188.456 230.67 188.456C231.023 188.456 231.31 188.169 231.31 187.816C231.31 187.463 231.023 187.176 230.67 187.176C230.317 187.176 230.03 187.463 230.03 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 187.816C213.39 188.169 213.676 188.456 214.03 188.456C214.383 188.456 214.67 188.169 214.67 187.816C214.67 187.463 214.383 187.176 214.03 187.176C213.676 187.176 213.39 187.463 213.39 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 187.816C196.749 188.169 197.036 188.456 197.389 188.456C197.742 188.456 198.029 188.169 198.029 187.816C198.029 187.463 197.742 187.176 197.389 187.176C197.036 187.176 196.749 187.463 196.749 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 204.457C346.514 204.81 346.8 205.097 347.154 205.097C347.507 205.097 347.794 204.81 347.794 204.457C347.794 204.103 347.507 203.817 347.154 203.817C346.8 203.817 346.514 204.103 346.514 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 204.457C329.873 204.81 330.16 205.097 330.513 205.097C330.867 205.097 331.153 204.81 331.153 204.457C331.153 204.103 330.867 203.817 330.513 203.817C330.16 203.817 329.873 204.103 329.873 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 204.457C313.233 204.81 313.519 205.097 313.873 205.097C314.226 205.097 314.513 204.81 314.513 204.457C314.513 204.103 314.226 203.817 313.873 203.817C313.519 203.817 313.233 204.103 313.233 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 204.457C296.592 204.81 296.879 205.097 297.232 205.097C297.586 205.097 297.872 204.81 297.872 204.457C297.872 204.103 297.586 203.817 297.232 203.817C296.879 203.817 296.592 204.103 296.592 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 204.457C279.952 204.81 280.238 205.097 280.592 205.097C280.945 205.097 281.232 204.81 281.232 204.457C281.232 204.103 280.945 203.817 280.592 203.817C280.238 203.817 279.952 204.103 279.952 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 204.457C263.311 204.81 263.598 205.097 263.951 205.097C264.304 205.097 264.591 204.81 264.591 204.457C264.591 204.103 264.304 203.817 263.951 203.817C263.598 203.817 263.311 204.103 263.311 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 204.457C246.671 204.81 246.957 205.097 247.311 205.097C247.664 205.097 247.951 204.81 247.951 204.457C247.951 204.103 247.664 203.817 247.311 203.817C246.957 203.817 246.671 204.103 246.671 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 204.457C230.03 204.81 230.317 205.097 230.67 205.097C231.023 205.097 231.31 204.81 231.31 204.457C231.31 204.103 231.023 203.817 230.67 203.817C230.317 203.817 230.03 204.103 230.03 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 204.457C213.39 204.81 213.676 205.097 214.03 205.097C214.383 205.097 214.67 204.81 214.67 204.457C214.67 204.103 214.383 203.817 214.03 203.817C213.676 203.817 213.39 204.103 213.39 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 204.457C196.749 204.81 197.036 205.097 197.389 205.097C197.742 205.097 198.029 204.81 198.029 204.457C198.029 204.103 197.742 203.817 197.389 203.817C197.036 203.817 196.749 204.103 196.749 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 221.097C346.514 221.45 346.8 221.737 347.154 221.737C347.507 221.737 347.794 221.45 347.794 221.097C347.794 220.744 347.507 220.457 347.154 220.457C346.8 220.457 346.514 220.744 346.514 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 221.097C329.873 221.45 330.16 221.737 330.513 221.737C330.867 221.737 331.153 221.45 331.153 221.097C331.153 220.744 330.867 220.457 330.513 220.457C330.16 220.457 329.873 220.744 329.873 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 221.097C313.233 221.45 313.519 221.737 313.873 221.737C314.226 221.737 314.513 221.45 314.513 221.097C314.513 220.744 314.226 220.457 313.873 220.457C313.519 220.457 313.233 220.744 313.233 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 221.097C296.592 221.45 296.879 221.737 297.232 221.737C297.586 221.737 297.872 221.45 297.872 221.097C297.872 220.744 297.586 220.457 297.232 220.457C296.879 220.457 296.592 220.744 296.592 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 221.097C279.952 221.45 280.238 221.737 280.592 221.737C280.945 221.737 281.232 221.45 281.232 221.097C281.232 220.744 280.945 220.457 280.592 220.457C280.238 220.457 279.952 220.744 279.952 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 221.097C263.311 221.45 263.598 221.737 263.951 221.737C264.304 221.737 264.591 221.45 264.591 221.097C264.591 220.744 264.304 220.457 263.951 220.457C263.598 220.457 263.311 220.744 263.311 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 221.097C246.671 221.45 246.957 221.737 247.311 221.737C247.664 221.737 247.951 221.45 247.951 221.097C247.951 220.744 247.664 220.457 247.311 220.457C246.957 220.457 246.671 220.744 246.671 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 221.097C230.03 221.45 230.317 221.737 230.67 221.737C231.023 221.737 231.31 221.45 231.31 221.097C231.31 220.744 231.023 220.457 230.67 220.457C230.317 220.457 230.03 220.744 230.03 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 221.097C213.39 221.45 213.676 221.737 214.03 221.737C214.383 221.737 214.67 221.45 214.67 221.097C214.67 220.744 214.383 220.457 214.03 220.457C213.676 220.457 213.39 220.744 213.39 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 221.097C196.749 221.45 197.036 221.737 197.389 221.737C197.742 221.737 198.029 221.45 198.029 221.097C198.029 220.744 197.742 220.457 197.389 220.457C197.036 220.457 196.749 220.744 196.749 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 237.738C346.514 238.091 346.8 238.378 347.154 238.378C347.507 238.378 347.794 238.091 347.794 237.738C347.794 237.384 347.507 237.098 347.154 237.098C346.8 237.098 346.514 237.384 346.514 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 237.738C329.873 238.091 330.16 238.378 330.513 238.378C330.867 238.378 331.153 238.091 331.153 237.738C331.153 237.384 330.867 237.098 330.513 237.098C330.16 237.098 329.873 237.384 329.873 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 237.738C313.233 238.091 313.519 238.378 313.873 238.378C314.226 238.378 314.513 238.091 314.513 237.738C314.513 237.384 314.226 237.098 313.873 237.098C313.519 237.098 313.233 237.384 313.233 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 237.738C296.592 238.091 296.879 238.378 297.232 238.378C297.586 238.378 297.872 238.091 297.872 237.738C297.872 237.384 297.586 237.098 297.232 237.098C296.879 237.098 296.592 237.384 296.592 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 237.738C279.952 238.091 280.238 238.378 280.592 238.378C280.945 238.378 281.232 238.091 281.232 237.738C281.232 237.384 280.945 237.098 280.592 237.098C280.238 237.098 279.952 237.384 279.952 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 237.738C263.311 238.091 263.598 238.378 263.951 238.378C264.304 238.378 264.591 238.091 264.591 237.738C264.591 237.384 264.304 237.098 263.951 237.098C263.598 237.098 263.311 237.384 263.311 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 237.738C246.671 238.091 246.957 238.378 247.311 238.378C247.664 238.378 247.951 238.091 247.951 237.738C247.951 237.384 247.664 237.098 247.311 237.098C246.957 237.098 246.671 237.384 246.671 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 237.738C230.03 238.091 230.317 238.378 230.67 238.378C231.023 238.378 231.31 238.091 231.31 237.738C231.31 237.384 231.023 237.098 230.67 237.098C230.317 237.098 230.03 237.384 230.03 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 237.738C213.39 238.091 213.676 238.378 214.03 238.378C214.383 238.378 214.67 238.091 214.67 237.738C214.67 237.384 214.383 237.098 214.03 237.098C213.676 237.098 213.39 237.384 213.39 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 237.738C196.749 238.091 197.036 238.378 197.389 238.378C197.742 238.378 198.029 238.091 198.029 237.738C198.029 237.384 197.742 237.098 197.389 237.098C197.036 237.098 196.749 237.384 196.749 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.514 254.378C346.514 254.732 346.8 255.018 347.154 255.018C347.507 255.018 347.794 254.732 347.794 254.378C347.794 254.025 347.507 253.738 347.154 253.738C346.8 253.738 346.514 254.025 346.514 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.873 254.378C329.873 254.732 330.16 255.018 330.513 255.018C330.867 255.018 331.153 254.732 331.153 254.378C331.153 254.025 330.867 253.738 330.513 253.738C330.16 253.738 329.873 254.025 329.873 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.233 254.378C313.233 254.732 313.519 255.018 313.873 255.018C314.226 255.018 314.513 254.732 314.513 254.378C314.513 254.025 314.226 253.738 313.873 253.738C313.519 253.738 313.233 254.025 313.233 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.592 254.378C296.592 254.732 296.879 255.018 297.232 255.018C297.586 255.018 297.872 254.732 297.872 254.378C297.872 254.025 297.586 253.738 297.232 253.738C296.879 253.738 296.592 254.025 296.592 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.952 254.378C279.952 254.732 280.238 255.018 280.592 255.018C280.945 255.018 281.232 254.732 281.232 254.378C281.232 254.025 280.945 253.738 280.592 253.738C280.238 253.738 279.952 254.025 279.952 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.311 254.378C263.311 254.732 263.598 255.018 263.951 255.018C264.304 255.018 264.591 254.732 264.591 254.378C264.591 254.025 264.304 253.738 263.951 253.738C263.598 253.738 263.311 254.025 263.311 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.671 254.378C246.671 254.732 246.957 255.018 247.311 255.018C247.664 255.018 247.951 254.732 247.951 254.378C247.951 254.025 247.664 253.738 247.311 253.738C246.957 253.738 246.671 254.025 246.671 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03 254.378C230.03 254.732 230.317 255.018 230.67 255.018C231.023 255.018 231.31 254.732 231.31 254.378C231.31 254.025 231.023 253.738 230.67 253.738C230.317 253.738 230.03 254.025 230.03 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39 254.378C213.39 254.732 213.676 255.018 214.03 255.018C214.383 255.018 214.67 254.732 214.67 254.378C214.67 254.025 214.383 253.738 214.03 253.738C213.676 253.738 213.39 254.025 213.39 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.749 254.378C196.749 254.732 197.036 255.018 197.389 255.018C197.742 255.018 198.029 254.732 198.029 254.378C198.029 254.025 197.742 253.738 197.389 253.738C197.036 253.738 196.749 254.025 196.749 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_664_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.624 71.3324C201.624 71.6859 201.337 71.9724 200.984 71.9724C200.63 71.9724 200.344 71.6859 200.344 71.3324C200.344 70.9789 200.63 70.6924 200.984 70.6924C201.337 70.6924 201.624 70.9789 201.624 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 71.3324C218.264 71.6859 217.978 71.9724 217.624 71.9724C217.271 71.9724 216.984 71.6859 216.984 71.3324C216.984 70.9789 217.271 70.6924 217.624 70.6924C217.978 70.6924 218.264 70.9789 218.264 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 71.3324C234.905 71.6859 234.618 71.9724 234.265 71.9724C233.911 71.9724 233.625 71.6859 233.625 71.3324C233.625 70.9789 233.911 70.6924 234.265 70.6924C234.618 70.6924 234.905 70.9789 234.905 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 71.3324C251.545 71.6859 251.259 71.9724 250.905 71.9724C250.552 71.9724 250.265 71.6859 250.265 71.3324C250.265 70.9789 250.552 70.6924 250.905 70.6924C251.259 70.6924 251.545 70.9789 251.545 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 71.3324C268.186 71.6859 267.899 71.9724 267.546 71.9724C267.192 71.9724 266.906 71.6859 266.906 71.3324C266.906 70.9789 267.192 70.6924 267.546 70.6924C267.899 70.6924 268.186 70.9789 268.186 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 71.3324C284.826 71.6859 284.54 71.9724 284.186 71.9724C283.833 71.9724 283.546 71.6859 283.546 71.3324C283.546 70.9789 283.833 70.6924 284.186 70.6924C284.54 70.6924 284.826 70.9789 284.826 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 71.3324C301.467 71.6859 301.18 71.9724 300.827 71.9724C300.474 71.9724 300.187 71.6859 300.187 71.3324C300.187 70.9789 300.474 70.6924 300.827 70.6924C301.18 70.6924 301.467 70.9789 301.467 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 71.3324C318.107 71.6859 317.821 71.9724 317.467 71.9724C317.114 71.9724 316.827 71.6859 316.827 71.3324C316.827 70.9789 317.114 70.6924 317.467 70.6924C317.821 70.6924 318.107 70.9789 318.107 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 71.3324C334.748 71.6859 334.461 71.9724 334.108 71.9724C333.755 71.9724 333.468 71.6859 333.468 71.3324C333.468 70.9789 333.755 70.6924 334.108 70.6924C334.461 70.6924 334.748 70.9789 334.748 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 71.3324C351.388 71.6859 351.102 71.9724 350.748 71.9724C350.395 71.9724 350.108 71.6859 350.108 71.3324C350.108 70.9789 350.395 70.6924 350.748 70.6924C351.102 70.6924 351.388 70.9789 351.388 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 87.973C201.624 88.3264 201.337 88.613 200.984 88.613C200.63 88.613 200.344 88.3264 200.344 87.973C200.344 87.6196 200.63 87.333 200.984 87.333C201.337 87.333 201.624 87.6196 201.624 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 87.973C218.264 88.3264 217.978 88.613 217.624 88.613C217.271 88.613 216.984 88.3264 216.984 87.973C216.984 87.6196 217.271 87.333 217.624 87.333C217.978 87.333 218.264 87.6196 218.264 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 87.973C234.905 88.3264 234.618 88.613 234.265 88.613C233.911 88.613 233.625 88.3264 233.625 87.973C233.625 87.6196 233.911 87.333 234.265 87.333C234.618 87.333 234.905 87.6196 234.905 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 87.973C251.545 88.3264 251.259 88.613 250.905 88.613C250.552 88.613 250.265 88.3264 250.265 87.973C250.265 87.6196 250.552 87.333 250.905 87.333C251.259 87.333 251.545 87.6196 251.545 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 87.973C268.186 88.3264 267.899 88.613 267.546 88.613C267.192 88.613 266.906 88.3264 266.906 87.973C266.906 87.6196 267.192 87.333 267.546 87.333C267.899 87.333 268.186 87.6196 268.186 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 87.973C284.826 88.3264 284.54 88.613 284.186 88.613C283.833 88.613 283.546 88.3264 283.546 87.973C283.546 87.6196 283.833 87.333 284.186 87.333C284.54 87.333 284.826 87.6196 284.826 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 87.973C301.467 88.3264 301.18 88.613 300.827 88.613C300.474 88.613 300.187 88.3264 300.187 87.973C300.187 87.6196 300.474 87.333 300.827 87.333C301.18 87.333 301.467 87.6196 301.467 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 87.973C318.107 88.3264 317.821 88.613 317.467 88.613C317.114 88.613 316.827 88.3264 316.827 87.973C316.827 87.6196 317.114 87.333 317.467 87.333C317.821 87.333 318.107 87.6196 318.107 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 87.973C334.748 88.3264 334.461 88.613 334.108 88.613C333.755 88.613 333.468 88.3264 333.468 87.973C333.468 87.6196 333.755 87.333 334.108 87.333C334.461 87.333 334.748 87.6196 334.748 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 87.973C351.388 88.3264 351.102 88.613 350.748 88.613C350.395 88.613 350.108 88.3264 350.108 87.973C350.108 87.6196 350.395 87.333 350.748 87.333C351.102 87.333 351.388 87.6196 351.388 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 104.613C201.624 104.967 201.337 105.253 200.984 105.253C200.63 105.253 200.344 104.967 200.344 104.613C200.344 104.26 200.63 103.973 200.984 103.973C201.337 103.973 201.624 104.26 201.624 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 104.613C218.264 104.967 217.978 105.253 217.624 105.253C217.271 105.253 216.984 104.967 216.984 104.613C216.984 104.26 217.271 103.973 217.624 103.973C217.978 103.973 218.264 104.26 218.264 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 104.613C234.905 104.967 234.618 105.253 234.265 105.253C233.911 105.253 233.625 104.967 233.625 104.613C233.625 104.26 233.911 103.973 234.265 103.973C234.618 103.973 234.905 104.26 234.905 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 104.613C251.545 104.967 251.259 105.253 250.905 105.253C250.552 105.253 250.265 104.967 250.265 104.613C250.265 104.26 250.552 103.973 250.905 103.973C251.259 103.973 251.545 104.26 251.545 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 104.613C268.186 104.967 267.899 105.253 267.546 105.253C267.192 105.253 266.906 104.967 266.906 104.613C266.906 104.26 267.192 103.973 267.546 103.973C267.899 103.973 268.186 104.26 268.186 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 104.613C284.826 104.967 284.54 105.253 284.186 105.253C283.833 105.253 283.546 104.967 283.546 104.613C283.546 104.26 283.833 103.973 284.186 103.973C284.54 103.973 284.826 104.26 284.826 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 104.613C301.467 104.967 301.18 105.253 300.827 105.253C300.474 105.253 300.187 104.967 300.187 104.613C300.187 104.26 300.474 103.973 300.827 103.973C301.18 103.973 301.467 104.26 301.467 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 104.613C318.107 104.967 317.821 105.253 317.467 105.253C317.114 105.253 316.827 104.967 316.827 104.613C316.827 104.26 317.114 103.973 317.467 103.973C317.821 103.973 318.107 104.26 318.107 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 104.613C334.748 104.967 334.461 105.253 334.108 105.253C333.755 105.253 333.468 104.967 333.468 104.613C333.468 104.26 333.755 103.973 334.108 103.973C334.461 103.973 334.748 104.26 334.748 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 104.613C351.388 104.967 351.102 105.253 350.748 105.253C350.395 105.253 350.108 104.967 350.108 104.613C350.108 104.26 350.395 103.973 350.748 103.973C351.102 103.973 351.388 104.26 351.388 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 121.254C201.624 121.607 201.337 121.894 200.984 121.894C200.63 121.894 200.344 121.607 200.344 121.254C200.344 120.901 200.63 120.614 200.984 120.614C201.337 120.614 201.624 120.901 201.624 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 121.254C218.264 121.607 217.978 121.894 217.624 121.894C217.271 121.894 216.984 121.607 216.984 121.254C216.984 120.901 217.271 120.614 217.624 120.614C217.978 120.614 218.264 120.901 218.264 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 121.254C234.905 121.607 234.618 121.894 234.265 121.894C233.911 121.894 233.625 121.607 233.625 121.254C233.625 120.901 233.911 120.614 234.265 120.614C234.618 120.614 234.905 120.901 234.905 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 121.254C251.545 121.607 251.259 121.894 250.905 121.894C250.552 121.894 250.265 121.607 250.265 121.254C250.265 120.901 250.552 120.614 250.905 120.614C251.259 120.614 251.545 120.901 251.545 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 121.254C268.186 121.607 267.899 121.894 267.546 121.894C267.192 121.894 266.906 121.607 266.906 121.254C266.906 120.901 267.192 120.614 267.546 120.614C267.899 120.614 268.186 120.901 268.186 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 121.254C284.826 121.607 284.54 121.894 284.186 121.894C283.833 121.894 283.546 121.607 283.546 121.254C283.546 120.901 283.833 120.614 284.186 120.614C284.54 120.614 284.826 120.901 284.826 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 121.254C301.467 121.607 301.18 121.894 300.827 121.894C300.474 121.894 300.187 121.607 300.187 121.254C300.187 120.901 300.474 120.614 300.827 120.614C301.18 120.614 301.467 120.901 301.467 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 121.254C318.107 121.607 317.821 121.894 317.467 121.894C317.114 121.894 316.827 121.607 316.827 121.254C316.827 120.901 317.114 120.614 317.467 120.614C317.821 120.614 318.107 120.901 318.107 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 121.254C334.748 121.607 334.461 121.894 334.108 121.894C333.755 121.894 333.468 121.607 333.468 121.254C333.468 120.901 333.755 120.614 334.108 120.614C334.461 120.614 334.748 120.901 334.748 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 121.254C351.388 121.607 351.102 121.894 350.748 121.894C350.395 121.894 350.108 121.607 350.108 121.254C350.108 120.901 350.395 120.614 350.748 120.614C351.102 120.614 351.388 120.901 351.388 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 137.894C201.624 138.248 201.337 138.534 200.984 138.534C200.63 138.534 200.344 138.248 200.344 137.894C200.344 137.541 200.63 137.254 200.984 137.254C201.337 137.254 201.624 137.541 201.624 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 137.894C218.264 138.248 217.978 138.534 217.624 138.534C217.271 138.534 216.984 138.248 216.984 137.894C216.984 137.541 217.271 137.254 217.624 137.254C217.978 137.254 218.264 137.541 218.264 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 137.894C234.905 138.248 234.618 138.534 234.265 138.534C233.911 138.534 233.625 138.248 233.625 137.894C233.625 137.541 233.911 137.254 234.265 137.254C234.618 137.254 234.905 137.541 234.905 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 137.894C251.545 138.248 251.259 138.534 250.905 138.534C250.552 138.534 250.265 138.248 250.265 137.894C250.265 137.541 250.552 137.254 250.905 137.254C251.259 137.254 251.545 137.541 251.545 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 137.894C268.186 138.248 267.899 138.534 267.546 138.534C267.192 138.534 266.906 138.248 266.906 137.894C266.906 137.541 267.192 137.254 267.546 137.254C267.899 137.254 268.186 137.541 268.186 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 137.894C284.826 138.248 284.54 138.534 284.186 138.534C283.833 138.534 283.546 138.248 283.546 137.894C283.546 137.541 283.833 137.254 284.186 137.254C284.54 137.254 284.826 137.541 284.826 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 137.894C301.467 138.248 301.18 138.534 300.827 138.534C300.474 138.534 300.187 138.248 300.187 137.894C300.187 137.541 300.474 137.254 300.827 137.254C301.18 137.254 301.467 137.541 301.467 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 137.894C318.107 138.248 317.821 138.534 317.467 138.534C317.114 138.534 316.827 138.248 316.827 137.894C316.827 137.541 317.114 137.254 317.467 137.254C317.821 137.254 318.107 137.541 318.107 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 137.894C334.748 138.248 334.461 138.534 334.108 138.534C333.755 138.534 333.468 138.248 333.468 137.894C333.468 137.541 333.755 137.254 334.108 137.254C334.461 137.254 334.748 137.541 334.748 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 137.894C351.388 138.248 351.102 138.534 350.748 138.534C350.395 138.534 350.108 138.248 350.108 137.894C350.108 137.541 350.395 137.254 350.748 137.254C351.102 137.254 351.388 137.541 351.388 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 154.535C201.624 154.888 201.337 155.175 200.984 155.175C200.63 155.175 200.344 154.888 200.344 154.535C200.344 154.182 200.63 153.895 200.984 153.895C201.337 153.895 201.624 154.182 201.624 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 154.535C218.264 154.888 217.978 155.175 217.624 155.175C217.271 155.175 216.984 154.888 216.984 154.535C216.984 154.182 217.271 153.895 217.624 153.895C217.978 153.895 218.264 154.182 218.264 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 154.535C234.905 154.888 234.618 155.175 234.265 155.175C233.911 155.175 233.625 154.888 233.625 154.535C233.625 154.182 233.911 153.895 234.265 153.895C234.618 153.895 234.905 154.182 234.905 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 154.535C251.545 154.888 251.259 155.175 250.905 155.175C250.552 155.175 250.265 154.888 250.265 154.535C250.265 154.182 250.552 153.895 250.905 153.895C251.259 153.895 251.545 154.182 251.545 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 154.535C268.186 154.888 267.899 155.175 267.546 155.175C267.192 155.175 266.906 154.888 266.906 154.535C266.906 154.182 267.192 153.895 267.546 153.895C267.899 153.895 268.186 154.182 268.186 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 154.535C284.826 154.888 284.54 155.175 284.186 155.175C283.833 155.175 283.546 154.888 283.546 154.535C283.546 154.182 283.833 153.895 284.186 153.895C284.54 153.895 284.826 154.182 284.826 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 154.535C301.467 154.888 301.18 155.175 300.827 155.175C300.474 155.175 300.187 154.888 300.187 154.535C300.187 154.182 300.474 153.895 300.827 153.895C301.18 153.895 301.467 154.182 301.467 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 154.535C318.107 154.888 317.821 155.175 317.467 155.175C317.114 155.175 316.827 154.888 316.827 154.535C316.827 154.182 317.114 153.895 317.467 153.895C317.821 153.895 318.107 154.182 318.107 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 154.535C334.748 154.888 334.461 155.175 334.108 155.175C333.755 155.175 333.468 154.888 333.468 154.535C333.468 154.182 333.755 153.895 334.108 153.895C334.461 153.895 334.748 154.182 334.748 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 154.535C351.388 154.888 351.102 155.175 350.748 155.175C350.395 155.175 350.108 154.888 350.108 154.535C350.108 154.182 350.395 153.895 350.748 153.895C351.102 153.895 351.388 154.182 351.388 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 171.176C201.624 171.529 201.337 171.816 200.984 171.816C200.63 171.816 200.344 171.529 200.344 171.176C200.344 170.822 200.63 170.536 200.984 170.536C201.337 170.536 201.624 170.822 201.624 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 171.176C218.264 171.529 217.978 171.816 217.624 171.816C217.271 171.816 216.984 171.529 216.984 171.176C216.984 170.822 217.271 170.536 217.624 170.536C217.978 170.536 218.264 170.822 218.264 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 171.176C234.905 171.529 234.618 171.816 234.265 171.816C233.911 171.816 233.625 171.529 233.625 171.176C233.625 170.822 233.911 170.536 234.265 170.536C234.618 170.536 234.905 170.822 234.905 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 171.176C251.545 171.529 251.259 171.816 250.905 171.816C250.552 171.816 250.265 171.529 250.265 171.176C250.265 170.822 250.552 170.536 250.905 170.536C251.259 170.536 251.545 170.822 251.545 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 171.176C268.186 171.529 267.899 171.816 267.546 171.816C267.192 171.816 266.906 171.529 266.906 171.176C266.906 170.822 267.192 170.536 267.546 170.536C267.899 170.536 268.186 170.822 268.186 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 171.176C284.826 171.529 284.54 171.816 284.186 171.816C283.833 171.816 283.546 171.529 283.546 171.176C283.546 170.822 283.833 170.536 284.186 170.536C284.54 170.536 284.826 170.822 284.826 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 171.176C301.467 171.529 301.18 171.816 300.827 171.816C300.474 171.816 300.187 171.529 300.187 171.176C300.187 170.822 300.474 170.536 300.827 170.536C301.18 170.536 301.467 170.822 301.467 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 171.176C318.107 171.529 317.821 171.816 317.467 171.816C317.114 171.816 316.827 171.529 316.827 171.176C316.827 170.822 317.114 170.536 317.467 170.536C317.821 170.536 318.107 170.822 318.107 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 171.176C334.748 171.529 334.461 171.816 334.108 171.816C333.755 171.816 333.468 171.529 333.468 171.176C333.468 170.822 333.755 170.536 334.108 170.536C334.461 170.536 334.748 170.822 334.748 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 171.176C351.388 171.529 351.102 171.816 350.748 171.816C350.395 171.816 350.108 171.529 350.108 171.176C350.108 170.822 350.395 170.536 350.748 170.536C351.102 170.536 351.388 170.822 351.388 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 187.816C201.624 188.169 201.337 188.456 200.984 188.456C200.63 188.456 200.344 188.169 200.344 187.816C200.344 187.463 200.63 187.176 200.984 187.176C201.337 187.176 201.624 187.463 201.624 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 187.816C218.264 188.169 217.978 188.456 217.624 188.456C217.271 188.456 216.984 188.169 216.984 187.816C216.984 187.463 217.271 187.176 217.624 187.176C217.978 187.176 218.264 187.463 218.264 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 187.816C234.905 188.169 234.618 188.456 234.265 188.456C233.911 188.456 233.625 188.169 233.625 187.816C233.625 187.463 233.911 187.176 234.265 187.176C234.618 187.176 234.905 187.463 234.905 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 187.816C251.545 188.169 251.259 188.456 250.905 188.456C250.552 188.456 250.265 188.169 250.265 187.816C250.265 187.463 250.552 187.176 250.905 187.176C251.259 187.176 251.545 187.463 251.545 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 187.816C268.186 188.169 267.899 188.456 267.546 188.456C267.192 188.456 266.906 188.169 266.906 187.816C266.906 187.463 267.192 187.176 267.546 187.176C267.899 187.176 268.186 187.463 268.186 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 187.816C284.826 188.169 284.54 188.456 284.186 188.456C283.833 188.456 283.546 188.169 283.546 187.816C283.546 187.463 283.833 187.176 284.186 187.176C284.54 187.176 284.826 187.463 284.826 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 187.816C301.467 188.169 301.18 188.456 300.827 188.456C300.474 188.456 300.187 188.169 300.187 187.816C300.187 187.463 300.474 187.176 300.827 187.176C301.18 187.176 301.467 187.463 301.467 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 187.816C318.107 188.169 317.821 188.456 317.467 188.456C317.114 188.456 316.827 188.169 316.827 187.816C316.827 187.463 317.114 187.176 317.467 187.176C317.821 187.176 318.107 187.463 318.107 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 187.816C334.748 188.169 334.461 188.456 334.108 188.456C333.755 188.456 333.468 188.169 333.468 187.816C333.468 187.463 333.755 187.176 334.108 187.176C334.461 187.176 334.748 187.463 334.748 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 187.816C351.388 188.169 351.102 188.456 350.748 188.456C350.395 188.456 350.108 188.169 350.108 187.816C350.108 187.463 350.395 187.176 350.748 187.176C351.102 187.176 351.388 187.463 351.388 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 204.457C201.624 204.81 201.337 205.097 200.984 205.097C200.63 205.097 200.344 204.81 200.344 204.457C200.344 204.103 200.63 203.817 200.984 203.817C201.337 203.817 201.624 204.103 201.624 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 204.457C218.264 204.81 217.978 205.097 217.624 205.097C217.271 205.097 216.984 204.81 216.984 204.457C216.984 204.103 217.271 203.817 217.624 203.817C217.978 203.817 218.264 204.103 218.264 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 204.457C234.905 204.81 234.618 205.097 234.265 205.097C233.911 205.097 233.625 204.81 233.625 204.457C233.625 204.103 233.911 203.817 234.265 203.817C234.618 203.817 234.905 204.103 234.905 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 204.457C251.545 204.81 251.259 205.097 250.905 205.097C250.552 205.097 250.265 204.81 250.265 204.457C250.265 204.103 250.552 203.817 250.905 203.817C251.259 203.817 251.545 204.103 251.545 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 204.457C268.186 204.81 267.899 205.097 267.546 205.097C267.192 205.097 266.906 204.81 266.906 204.457C266.906 204.103 267.192 203.817 267.546 203.817C267.899 203.817 268.186 204.103 268.186 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 204.457C284.826 204.81 284.54 205.097 284.186 205.097C283.833 205.097 283.546 204.81 283.546 204.457C283.546 204.103 283.833 203.817 284.186 203.817C284.54 203.817 284.826 204.103 284.826 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 204.457C301.467 204.81 301.18 205.097 300.827 205.097C300.474 205.097 300.187 204.81 300.187 204.457C300.187 204.103 300.474 203.817 300.827 203.817C301.18 203.817 301.467 204.103 301.467 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 204.457C318.107 204.81 317.821 205.097 317.467 205.097C317.114 205.097 316.827 204.81 316.827 204.457C316.827 204.103 317.114 203.817 317.467 203.817C317.821 203.817 318.107 204.103 318.107 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 204.457C334.748 204.81 334.461 205.097 334.108 205.097C333.755 205.097 333.468 204.81 333.468 204.457C333.468 204.103 333.755 203.817 334.108 203.817C334.461 203.817 334.748 204.103 334.748 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 204.457C351.388 204.81 351.102 205.097 350.748 205.097C350.395 205.097 350.108 204.81 350.108 204.457C350.108 204.103 350.395 203.817 350.748 203.817C351.102 203.817 351.388 204.103 351.388 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 221.097C201.624 221.45 201.337 221.737 200.984 221.737C200.63 221.737 200.344 221.45 200.344 221.097C200.344 220.744 200.63 220.457 200.984 220.457C201.337 220.457 201.624 220.744 201.624 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 221.097C218.264 221.45 217.978 221.737 217.624 221.737C217.271 221.737 216.984 221.45 216.984 221.097C216.984 220.744 217.271 220.457 217.624 220.457C217.978 220.457 218.264 220.744 218.264 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 221.097C234.905 221.45 234.618 221.737 234.265 221.737C233.911 221.737 233.625 221.45 233.625 221.097C233.625 220.744 233.911 220.457 234.265 220.457C234.618 220.457 234.905 220.744 234.905 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 221.097C251.545 221.45 251.259 221.737 250.905 221.737C250.552 221.737 250.265 221.45 250.265 221.097C250.265 220.744 250.552 220.457 250.905 220.457C251.259 220.457 251.545 220.744 251.545 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 221.097C268.186 221.45 267.899 221.737 267.546 221.737C267.192 221.737 266.906 221.45 266.906 221.097C266.906 220.744 267.192 220.457 267.546 220.457C267.899 220.457 268.186 220.744 268.186 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 221.097C284.826 221.45 284.54 221.737 284.186 221.737C283.833 221.737 283.546 221.45 283.546 221.097C283.546 220.744 283.833 220.457 284.186 220.457C284.54 220.457 284.826 220.744 284.826 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 221.097C301.467 221.45 301.18 221.737 300.827 221.737C300.474 221.737 300.187 221.45 300.187 221.097C300.187 220.744 300.474 220.457 300.827 220.457C301.18 220.457 301.467 220.744 301.467 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 221.097C318.107 221.45 317.821 221.737 317.467 221.737C317.114 221.737 316.827 221.45 316.827 221.097C316.827 220.744 317.114 220.457 317.467 220.457C317.821 220.457 318.107 220.744 318.107 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 221.097C334.748 221.45 334.461 221.737 334.108 221.737C333.755 221.737 333.468 221.45 333.468 221.097C333.468 220.744 333.755 220.457 334.108 220.457C334.461 220.457 334.748 220.744 334.748 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 221.097C351.388 221.45 351.102 221.737 350.748 221.737C350.395 221.737 350.108 221.45 350.108 221.097C350.108 220.744 350.395 220.457 350.748 220.457C351.102 220.457 351.388 220.744 351.388 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 237.738C201.624 238.091 201.337 238.378 200.984 238.378C200.63 238.378 200.344 238.091 200.344 237.738C200.344 237.384 200.63 237.098 200.984 237.098C201.337 237.098 201.624 237.384 201.624 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 237.738C218.264 238.091 217.978 238.378 217.624 238.378C217.271 238.378 216.984 238.091 216.984 237.738C216.984 237.384 217.271 237.098 217.624 237.098C217.978 237.098 218.264 237.384 218.264 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 237.738C234.905 238.091 234.618 238.378 234.265 238.378C233.911 238.378 233.625 238.091 233.625 237.738C233.625 237.384 233.911 237.098 234.265 237.098C234.618 237.098 234.905 237.384 234.905 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 237.738C251.545 238.091 251.259 238.378 250.905 238.378C250.552 238.378 250.265 238.091 250.265 237.738C250.265 237.384 250.552 237.098 250.905 237.098C251.259 237.098 251.545 237.384 251.545 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 237.738C268.186 238.091 267.899 238.378 267.546 238.378C267.192 238.378 266.906 238.091 266.906 237.738C266.906 237.384 267.192 237.098 267.546 237.098C267.899 237.098 268.186 237.384 268.186 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 237.738C284.826 238.091 284.54 238.378 284.186 238.378C283.833 238.378 283.546 238.091 283.546 237.738C283.546 237.384 283.833 237.098 284.186 237.098C284.54 237.098 284.826 237.384 284.826 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 237.738C301.467 238.091 301.18 238.378 300.827 238.378C300.474 238.378 300.187 238.091 300.187 237.738C300.187 237.384 300.474 237.098 300.827 237.098C301.18 237.098 301.467 237.384 301.467 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 237.738C318.107 238.091 317.821 238.378 317.467 238.378C317.114 238.378 316.827 238.091 316.827 237.738C316.827 237.384 317.114 237.098 317.467 237.098C317.821 237.098 318.107 237.384 318.107 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 237.738C334.748 238.091 334.461 238.378 334.108 238.378C333.755 238.378 333.468 238.091 333.468 237.738C333.468 237.384 333.755 237.098 334.108 237.098C334.461 237.098 334.748 237.384 334.748 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 237.738C351.388 238.091 351.102 238.378 350.748 238.378C350.395 238.378 350.108 238.091 350.108 237.738C350.108 237.384 350.395 237.098 350.748 237.098C351.102 237.098 351.388 237.384 351.388 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.624 254.378C201.624 254.732 201.337 255.018 200.984 255.018C200.63 255.018 200.344 254.732 200.344 254.378C200.344 254.025 200.63 253.738 200.984 253.738C201.337 253.738 201.624 254.025 201.624 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.264 254.378C218.264 254.732 217.978 255.018 217.624 255.018C217.271 255.018 216.984 254.732 216.984 254.378C216.984 254.025 217.271 253.738 217.624 253.738C217.978 253.738 218.264 254.025 218.264 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.905 254.378C234.905 254.732 234.618 255.018 234.265 255.018C233.911 255.018 233.625 254.732 233.625 254.378C233.625 254.025 233.911 253.738 234.265 253.738C234.618 253.738 234.905 254.025 234.905 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.545 254.378C251.545 254.732 251.259 255.018 250.905 255.018C250.552 255.018 250.265 254.732 250.265 254.378C250.265 254.025 250.552 253.738 250.905 253.738C251.259 253.738 251.545 254.025 251.545 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.186 254.378C268.186 254.732 267.899 255.018 267.546 255.018C267.192 255.018 266.906 254.732 266.906 254.378C266.906 254.025 267.192 253.738 267.546 253.738C267.899 253.738 268.186 254.025 268.186 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 254.378C284.826 254.732 284.54 255.018 284.186 255.018C283.833 255.018 283.546 254.732 283.546 254.378C283.546 254.025 283.833 253.738 284.186 253.738C284.54 253.738 284.826 254.025 284.826 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 254.378C301.467 254.732 301.18 255.018 300.827 255.018C300.474 255.018 300.187 254.732 300.187 254.378C300.187 254.025 300.474 253.738 300.827 253.738C301.18 253.738 301.467 254.025 301.467 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.107 254.378C318.107 254.732 317.821 255.018 317.467 255.018C317.114 255.018 316.827 254.732 316.827 254.378C316.827 254.025 317.114 253.738 317.467 253.738C317.821 253.738 318.107 254.025 318.107 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.748 254.378C334.748 254.732 334.461 255.018 334.108 255.018C333.755 255.018 333.468 254.732 333.468 254.378C333.468 254.025 333.755 253.738 334.108 253.738C334.461 253.738 334.748 254.025 334.748 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.388 254.378C351.388 254.732 351.102 255.018 350.748 255.018C350.395 255.018 350.108 254.732 350.108 254.378C350.108 254.025 350.395 253.738 350.748 253.738C351.102 253.738 351.388 254.025 351.388 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 71.3324C516.514 71.6859 516.8 71.9724 517.154 71.9724C517.507 71.9724 517.794 71.6859 517.794 71.3324C517.794 70.9789 517.507 70.6924 517.154 70.6924C516.8 70.6924 516.514 70.9789 516.514 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 71.3324C499.873 71.6859 500.16 71.9724 500.513 71.9724C500.867 71.9724 501.153 71.6859 501.153 71.3324C501.153 70.9789 500.867 70.6924 500.513 70.6924C500.16 70.6924 499.873 70.9789 499.873 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 71.3324C483.233 71.6859 483.519 71.9724 483.873 71.9724C484.226 71.9724 484.513 71.6859 484.513 71.3324C484.513 70.9789 484.226 70.6924 483.873 70.6924C483.519 70.6924 483.233 70.9789 483.233 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 71.3324C466.592 71.6859 466.879 71.9724 467.232 71.9724C467.586 71.9724 467.872 71.6859 467.872 71.3324C467.872 70.9789 467.586 70.6924 467.232 70.6924C466.879 70.6924 466.592 70.9789 466.592 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 71.3324C449.952 71.6859 450.238 71.9724 450.592 71.9724C450.945 71.9724 451.232 71.6859 451.232 71.3324C451.232 70.9789 450.945 70.6924 450.592 70.6924C450.238 70.6924 449.952 70.9789 449.952 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 71.3324C433.311 71.6859 433.598 71.9724 433.951 71.9724C434.304 71.9724 434.591 71.6859 434.591 71.3324C434.591 70.9789 434.304 70.6924 433.951 70.6924C433.598 70.6924 433.311 70.9789 433.311 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 71.3324C416.671 71.6859 416.957 71.9724 417.311 71.9724C417.664 71.9724 417.951 71.6859 417.951 71.3324C417.951 70.9789 417.664 70.6924 417.311 70.6924C416.957 70.6924 416.671 70.9789 416.671 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 71.3324C400.03 71.6859 400.317 71.9724 400.67 71.9724C401.023 71.9724 401.31 71.6859 401.31 71.3324C401.31 70.9789 401.023 70.6924 400.67 70.6924C400.317 70.6924 400.03 70.9789 400.03 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 71.3324C383.39 71.6859 383.676 71.9724 384.03 71.9724C384.383 71.9724 384.67 71.6859 384.67 71.3324C384.67 70.9789 384.383 70.6924 384.03 70.6924C383.676 70.6924 383.39 70.9789 383.39 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 71.3324C366.749 71.6859 367.036 71.9724 367.389 71.9724C367.742 71.9724 368.029 71.6859 368.029 71.3324C368.029 70.9789 367.742 70.6924 367.389 70.6924C367.036 70.6924 366.749 70.9789 366.749 71.3324Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 87.973C516.514 88.3264 516.8 88.613 517.154 88.613C517.507 88.613 517.794 88.3264 517.794 87.973C517.794 87.6196 517.507 87.333 517.154 87.333C516.8 87.333 516.514 87.6196 516.514 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 87.973C499.873 88.3264 500.16 88.613 500.513 88.613C500.867 88.613 501.153 88.3264 501.153 87.973C501.153 87.6196 500.867 87.333 500.513 87.333C500.16 87.333 499.873 87.6196 499.873 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 87.973C483.233 88.3264 483.519 88.613 483.873 88.613C484.226 88.613 484.513 88.3264 484.513 87.973C484.513 87.6196 484.226 87.333 483.873 87.333C483.519 87.333 483.233 87.6196 483.233 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 87.973C466.592 88.3264 466.879 88.613 467.232 88.613C467.586 88.613 467.872 88.3264 467.872 87.973C467.872 87.6196 467.586 87.333 467.232 87.333C466.879 87.333 466.592 87.6196 466.592 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 87.973C449.952 88.3264 450.238 88.613 450.592 88.613C450.945 88.613 451.232 88.3264 451.232 87.973C451.232 87.6196 450.945 87.333 450.592 87.333C450.238 87.333 449.952 87.6196 449.952 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 87.973C433.311 88.3264 433.598 88.613 433.951 88.613C434.304 88.613 434.591 88.3264 434.591 87.973C434.591 87.6196 434.304 87.333 433.951 87.333C433.598 87.333 433.311 87.6196 433.311 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 87.973C416.671 88.3264 416.957 88.613 417.311 88.613C417.664 88.613 417.951 88.3264 417.951 87.973C417.951 87.6196 417.664 87.333 417.311 87.333C416.957 87.333 416.671 87.6196 416.671 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 87.973C400.03 88.3264 400.317 88.613 400.67 88.613C401.023 88.613 401.31 88.3264 401.31 87.973C401.31 87.6196 401.023 87.333 400.67 87.333C400.317 87.333 400.03 87.6196 400.03 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 87.973C383.39 88.3264 383.676 88.613 384.03 88.613C384.383 88.613 384.67 88.3264 384.67 87.973C384.67 87.6196 384.383 87.333 384.03 87.333C383.676 87.333 383.39 87.6196 383.39 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 87.973C366.749 88.3264 367.036 88.613 367.389 88.613C367.742 88.613 368.029 88.3264 368.029 87.973C368.029 87.6196 367.742 87.333 367.389 87.333C367.036 87.333 366.749 87.6196 366.749 87.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 104.613C516.514 104.967 516.8 105.253 517.154 105.253C517.507 105.253 517.794 104.967 517.794 104.613C517.794 104.26 517.507 103.973 517.154 103.973C516.8 103.973 516.514 104.26 516.514 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 104.613C499.873 104.967 500.16 105.253 500.513 105.253C500.867 105.253 501.153 104.967 501.153 104.613C501.153 104.26 500.867 103.973 500.513 103.973C500.16 103.973 499.873 104.26 499.873 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 104.613C483.233 104.967 483.519 105.253 483.873 105.253C484.226 105.253 484.513 104.967 484.513 104.613C484.513 104.26 484.226 103.973 483.873 103.973C483.519 103.973 483.233 104.26 483.233 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 104.613C466.592 104.967 466.879 105.253 467.232 105.253C467.586 105.253 467.872 104.967 467.872 104.613C467.872 104.26 467.586 103.973 467.232 103.973C466.879 103.973 466.592 104.26 466.592 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 104.613C449.952 104.967 450.238 105.253 450.592 105.253C450.945 105.253 451.232 104.967 451.232 104.613C451.232 104.26 450.945 103.973 450.592 103.973C450.238 103.973 449.952 104.26 449.952 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 104.613C433.311 104.967 433.598 105.253 433.951 105.253C434.304 105.253 434.591 104.967 434.591 104.613C434.591 104.26 434.304 103.973 433.951 103.973C433.598 103.973 433.311 104.26 433.311 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 104.613C416.671 104.967 416.957 105.253 417.311 105.253C417.664 105.253 417.951 104.967 417.951 104.613C417.951 104.26 417.664 103.973 417.311 103.973C416.957 103.973 416.671 104.26 416.671 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 104.613C400.03 104.967 400.317 105.253 400.67 105.253C401.023 105.253 401.31 104.967 401.31 104.613C401.31 104.26 401.023 103.973 400.67 103.973C400.317 103.973 400.03 104.26 400.03 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 104.613C383.39 104.967 383.676 105.253 384.03 105.253C384.383 105.253 384.67 104.967 384.67 104.613C384.67 104.26 384.383 103.973 384.03 103.973C383.676 103.973 383.39 104.26 383.39 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 104.613C366.749 104.967 367.036 105.253 367.389 105.253C367.742 105.253 368.029 104.967 368.029 104.613C368.029 104.26 367.742 103.973 367.389 103.973C367.036 103.973 366.749 104.26 366.749 104.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 121.254C516.514 121.607 516.8 121.894 517.154 121.894C517.507 121.894 517.794 121.607 517.794 121.254C517.794 120.901 517.507 120.614 517.154 120.614C516.8 120.614 516.514 120.901 516.514 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 121.254C499.873 121.607 500.16 121.894 500.513 121.894C500.867 121.894 501.153 121.607 501.153 121.254C501.153 120.901 500.867 120.614 500.513 120.614C500.16 120.614 499.873 120.901 499.873 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 121.254C483.233 121.607 483.519 121.894 483.873 121.894C484.226 121.894 484.513 121.607 484.513 121.254C484.513 120.901 484.226 120.614 483.873 120.614C483.519 120.614 483.233 120.901 483.233 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 121.254C466.592 121.607 466.879 121.894 467.232 121.894C467.586 121.894 467.872 121.607 467.872 121.254C467.872 120.901 467.586 120.614 467.232 120.614C466.879 120.614 466.592 120.901 466.592 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 121.254C449.952 121.607 450.238 121.894 450.592 121.894C450.945 121.894 451.232 121.607 451.232 121.254C451.232 120.901 450.945 120.614 450.592 120.614C450.238 120.614 449.952 120.901 449.952 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 121.254C433.311 121.607 433.598 121.894 433.951 121.894C434.304 121.894 434.591 121.607 434.591 121.254C434.591 120.901 434.304 120.614 433.951 120.614C433.598 120.614 433.311 120.901 433.311 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 121.254C416.671 121.607 416.957 121.894 417.311 121.894C417.664 121.894 417.951 121.607 417.951 121.254C417.951 120.901 417.664 120.614 417.311 120.614C416.957 120.614 416.671 120.901 416.671 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 121.254C400.03 121.607 400.317 121.894 400.67 121.894C401.023 121.894 401.31 121.607 401.31 121.254C401.31 120.901 401.023 120.614 400.67 120.614C400.317 120.614 400.03 120.901 400.03 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 121.254C383.39 121.607 383.676 121.894 384.03 121.894C384.383 121.894 384.67 121.607 384.67 121.254C384.67 120.901 384.383 120.614 384.03 120.614C383.676 120.614 383.39 120.901 383.39 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 121.254C366.749 121.607 367.036 121.894 367.389 121.894C367.742 121.894 368.029 121.607 368.029 121.254C368.029 120.901 367.742 120.614 367.389 120.614C367.036 120.614 366.749 120.901 366.749 121.254Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 137.894C516.514 138.248 516.8 138.534 517.154 138.534C517.507 138.534 517.794 138.248 517.794 137.894C517.794 137.541 517.507 137.254 517.154 137.254C516.8 137.254 516.514 137.541 516.514 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 137.894C499.873 138.248 500.16 138.534 500.513 138.534C500.867 138.534 501.153 138.248 501.153 137.894C501.153 137.541 500.867 137.254 500.513 137.254C500.16 137.254 499.873 137.541 499.873 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 137.894C483.233 138.248 483.519 138.534 483.873 138.534C484.226 138.534 484.513 138.248 484.513 137.894C484.513 137.541 484.226 137.254 483.873 137.254C483.519 137.254 483.233 137.541 483.233 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 137.894C466.592 138.248 466.879 138.534 467.232 138.534C467.586 138.534 467.872 138.248 467.872 137.894C467.872 137.541 467.586 137.254 467.232 137.254C466.879 137.254 466.592 137.541 466.592 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 137.894C449.952 138.248 450.238 138.534 450.592 138.534C450.945 138.534 451.232 138.248 451.232 137.894C451.232 137.541 450.945 137.254 450.592 137.254C450.238 137.254 449.952 137.541 449.952 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 137.894C433.311 138.248 433.598 138.534 433.951 138.534C434.304 138.534 434.591 138.248 434.591 137.894C434.591 137.541 434.304 137.254 433.951 137.254C433.598 137.254 433.311 137.541 433.311 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 137.894C416.671 138.248 416.957 138.534 417.311 138.534C417.664 138.534 417.951 138.248 417.951 137.894C417.951 137.541 417.664 137.254 417.311 137.254C416.957 137.254 416.671 137.541 416.671 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 137.894C400.03 138.248 400.317 138.534 400.67 138.534C401.023 138.534 401.31 138.248 401.31 137.894C401.31 137.541 401.023 137.254 400.67 137.254C400.317 137.254 400.03 137.541 400.03 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 137.894C383.39 138.248 383.676 138.534 384.03 138.534C384.383 138.534 384.67 138.248 384.67 137.894C384.67 137.541 384.383 137.254 384.03 137.254C383.676 137.254 383.39 137.541 383.39 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 137.894C366.749 138.248 367.036 138.534 367.389 138.534C367.742 138.534 368.029 138.248 368.029 137.894C368.029 137.541 367.742 137.254 367.389 137.254C367.036 137.254 366.749 137.541 366.749 137.894Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 154.535C516.514 154.888 516.8 155.175 517.154 155.175C517.507 155.175 517.794 154.888 517.794 154.535C517.794 154.182 517.507 153.895 517.154 153.895C516.8 153.895 516.514 154.182 516.514 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 154.535C499.873 154.888 500.16 155.175 500.513 155.175C500.867 155.175 501.153 154.888 501.153 154.535C501.153 154.182 500.867 153.895 500.513 153.895C500.16 153.895 499.873 154.182 499.873 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 154.535C483.233 154.888 483.519 155.175 483.873 155.175C484.226 155.175 484.513 154.888 484.513 154.535C484.513 154.182 484.226 153.895 483.873 153.895C483.519 153.895 483.233 154.182 483.233 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 154.535C466.592 154.888 466.879 155.175 467.232 155.175C467.586 155.175 467.872 154.888 467.872 154.535C467.872 154.182 467.586 153.895 467.232 153.895C466.879 153.895 466.592 154.182 466.592 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 154.535C449.952 154.888 450.238 155.175 450.592 155.175C450.945 155.175 451.232 154.888 451.232 154.535C451.232 154.182 450.945 153.895 450.592 153.895C450.238 153.895 449.952 154.182 449.952 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 154.535C433.311 154.888 433.598 155.175 433.951 155.175C434.304 155.175 434.591 154.888 434.591 154.535C434.591 154.182 434.304 153.895 433.951 153.895C433.598 153.895 433.311 154.182 433.311 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 154.535C416.671 154.888 416.957 155.175 417.311 155.175C417.664 155.175 417.951 154.888 417.951 154.535C417.951 154.182 417.664 153.895 417.311 153.895C416.957 153.895 416.671 154.182 416.671 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 154.535C400.03 154.888 400.317 155.175 400.67 155.175C401.023 155.175 401.31 154.888 401.31 154.535C401.31 154.182 401.023 153.895 400.67 153.895C400.317 153.895 400.03 154.182 400.03 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 154.535C383.39 154.888 383.676 155.175 384.03 155.175C384.383 155.175 384.67 154.888 384.67 154.535C384.67 154.182 384.383 153.895 384.03 153.895C383.676 153.895 383.39 154.182 383.39 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 154.535C366.749 154.888 367.036 155.175 367.389 155.175C367.742 155.175 368.029 154.888 368.029 154.535C368.029 154.182 367.742 153.895 367.389 153.895C367.036 153.895 366.749 154.182 366.749 154.535Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 171.176C516.514 171.529 516.8 171.816 517.154 171.816C517.507 171.816 517.794 171.529 517.794 171.176C517.794 170.822 517.507 170.536 517.154 170.536C516.8 170.536 516.514 170.822 516.514 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 171.176C499.873 171.529 500.16 171.816 500.513 171.816C500.867 171.816 501.153 171.529 501.153 171.176C501.153 170.822 500.867 170.536 500.513 170.536C500.16 170.536 499.873 170.822 499.873 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 171.176C483.233 171.529 483.519 171.816 483.873 171.816C484.226 171.816 484.513 171.529 484.513 171.176C484.513 170.822 484.226 170.536 483.873 170.536C483.519 170.536 483.233 170.822 483.233 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 171.176C466.592 171.529 466.879 171.816 467.232 171.816C467.586 171.816 467.872 171.529 467.872 171.176C467.872 170.822 467.586 170.536 467.232 170.536C466.879 170.536 466.592 170.822 466.592 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 171.176C449.952 171.529 450.238 171.816 450.592 171.816C450.945 171.816 451.232 171.529 451.232 171.176C451.232 170.822 450.945 170.536 450.592 170.536C450.238 170.536 449.952 170.822 449.952 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 171.176C433.311 171.529 433.598 171.816 433.951 171.816C434.304 171.816 434.591 171.529 434.591 171.176C434.591 170.822 434.304 170.536 433.951 170.536C433.598 170.536 433.311 170.822 433.311 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 171.176C416.671 171.529 416.957 171.816 417.311 171.816C417.664 171.816 417.951 171.529 417.951 171.176C417.951 170.822 417.664 170.536 417.311 170.536C416.957 170.536 416.671 170.822 416.671 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 171.176C400.03 171.529 400.317 171.816 400.67 171.816C401.023 171.816 401.31 171.529 401.31 171.176C401.31 170.822 401.023 170.536 400.67 170.536C400.317 170.536 400.03 170.822 400.03 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 171.176C383.39 171.529 383.676 171.816 384.03 171.816C384.383 171.816 384.67 171.529 384.67 171.176C384.67 170.822 384.383 170.536 384.03 170.536C383.676 170.536 383.39 170.822 383.39 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 171.176C366.749 171.529 367.036 171.816 367.389 171.816C367.742 171.816 368.029 171.529 368.029 171.176C368.029 170.822 367.742 170.536 367.389 170.536C367.036 170.536 366.749 170.822 366.749 171.176Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 187.816C516.514 188.169 516.8 188.456 517.154 188.456C517.507 188.456 517.794 188.169 517.794 187.816C517.794 187.463 517.507 187.176 517.154 187.176C516.8 187.176 516.514 187.463 516.514 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 187.816C499.873 188.169 500.16 188.456 500.513 188.456C500.867 188.456 501.153 188.169 501.153 187.816C501.153 187.463 500.867 187.176 500.513 187.176C500.16 187.176 499.873 187.463 499.873 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 187.816C483.233 188.169 483.519 188.456 483.873 188.456C484.226 188.456 484.513 188.169 484.513 187.816C484.513 187.463 484.226 187.176 483.873 187.176C483.519 187.176 483.233 187.463 483.233 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 187.816C466.592 188.169 466.879 188.456 467.232 188.456C467.586 188.456 467.872 188.169 467.872 187.816C467.872 187.463 467.586 187.176 467.232 187.176C466.879 187.176 466.592 187.463 466.592 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 187.816C449.952 188.169 450.238 188.456 450.592 188.456C450.945 188.456 451.232 188.169 451.232 187.816C451.232 187.463 450.945 187.176 450.592 187.176C450.238 187.176 449.952 187.463 449.952 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 187.816C433.311 188.169 433.598 188.456 433.951 188.456C434.304 188.456 434.591 188.169 434.591 187.816C434.591 187.463 434.304 187.176 433.951 187.176C433.598 187.176 433.311 187.463 433.311 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 187.816C416.671 188.169 416.957 188.456 417.311 188.456C417.664 188.456 417.951 188.169 417.951 187.816C417.951 187.463 417.664 187.176 417.311 187.176C416.957 187.176 416.671 187.463 416.671 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 187.816C400.03 188.169 400.317 188.456 400.67 188.456C401.023 188.456 401.31 188.169 401.31 187.816C401.31 187.463 401.023 187.176 400.67 187.176C400.317 187.176 400.03 187.463 400.03 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 187.816C383.39 188.169 383.676 188.456 384.03 188.456C384.383 188.456 384.67 188.169 384.67 187.816C384.67 187.463 384.383 187.176 384.03 187.176C383.676 187.176 383.39 187.463 383.39 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 187.816C366.749 188.169 367.036 188.456 367.389 188.456C367.742 188.456 368.029 188.169 368.029 187.816C368.029 187.463 367.742 187.176 367.389 187.176C367.036 187.176 366.749 187.463 366.749 187.816Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 204.457C516.514 204.81 516.8 205.097 517.154 205.097C517.507 205.097 517.794 204.81 517.794 204.457C517.794 204.103 517.507 203.817 517.154 203.817C516.8 203.817 516.514 204.103 516.514 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 204.457C499.873 204.81 500.16 205.097 500.513 205.097C500.867 205.097 501.153 204.81 501.153 204.457C501.153 204.103 500.867 203.817 500.513 203.817C500.16 203.817 499.873 204.103 499.873 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 204.457C483.233 204.81 483.519 205.097 483.873 205.097C484.226 205.097 484.513 204.81 484.513 204.457C484.513 204.103 484.226 203.817 483.873 203.817C483.519 203.817 483.233 204.103 483.233 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 204.457C466.592 204.81 466.879 205.097 467.232 205.097C467.586 205.097 467.872 204.81 467.872 204.457C467.872 204.103 467.586 203.817 467.232 203.817C466.879 203.817 466.592 204.103 466.592 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 204.457C449.952 204.81 450.238 205.097 450.592 205.097C450.945 205.097 451.232 204.81 451.232 204.457C451.232 204.103 450.945 203.817 450.592 203.817C450.238 203.817 449.952 204.103 449.952 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 204.457C433.311 204.81 433.598 205.097 433.951 205.097C434.304 205.097 434.591 204.81 434.591 204.457C434.591 204.103 434.304 203.817 433.951 203.817C433.598 203.817 433.311 204.103 433.311 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 204.457C416.671 204.81 416.957 205.097 417.311 205.097C417.664 205.097 417.951 204.81 417.951 204.457C417.951 204.103 417.664 203.817 417.311 203.817C416.957 203.817 416.671 204.103 416.671 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 204.457C400.03 204.81 400.317 205.097 400.67 205.097C401.023 205.097 401.31 204.81 401.31 204.457C401.31 204.103 401.023 203.817 400.67 203.817C400.317 203.817 400.03 204.103 400.03 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 204.457C383.39 204.81 383.676 205.097 384.03 205.097C384.383 205.097 384.67 204.81 384.67 204.457C384.67 204.103 384.383 203.817 384.03 203.817C383.676 203.817 383.39 204.103 383.39 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 204.457C366.749 204.81 367.036 205.097 367.389 205.097C367.742 205.097 368.029 204.81 368.029 204.457C368.029 204.103 367.742 203.817 367.389 203.817C367.036 203.817 366.749 204.103 366.749 204.457Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 221.097C516.514 221.45 516.8 221.737 517.154 221.737C517.507 221.737 517.794 221.45 517.794 221.097C517.794 220.744 517.507 220.457 517.154 220.457C516.8 220.457 516.514 220.744 516.514 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 221.097C499.873 221.45 500.16 221.737 500.513 221.737C500.867 221.737 501.153 221.45 501.153 221.097C501.153 220.744 500.867 220.457 500.513 220.457C500.16 220.457 499.873 220.744 499.873 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 221.097C483.233 221.45 483.519 221.737 483.873 221.737C484.226 221.737 484.513 221.45 484.513 221.097C484.513 220.744 484.226 220.457 483.873 220.457C483.519 220.457 483.233 220.744 483.233 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 221.097C466.592 221.45 466.879 221.737 467.232 221.737C467.586 221.737 467.872 221.45 467.872 221.097C467.872 220.744 467.586 220.457 467.232 220.457C466.879 220.457 466.592 220.744 466.592 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 221.097C449.952 221.45 450.238 221.737 450.592 221.737C450.945 221.737 451.232 221.45 451.232 221.097C451.232 220.744 450.945 220.457 450.592 220.457C450.238 220.457 449.952 220.744 449.952 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 221.097C433.311 221.45 433.598 221.737 433.951 221.737C434.304 221.737 434.591 221.45 434.591 221.097C434.591 220.744 434.304 220.457 433.951 220.457C433.598 220.457 433.311 220.744 433.311 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 221.097C416.671 221.45 416.957 221.737 417.311 221.737C417.664 221.737 417.951 221.45 417.951 221.097C417.951 220.744 417.664 220.457 417.311 220.457C416.957 220.457 416.671 220.744 416.671 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 221.097C400.03 221.45 400.317 221.737 400.67 221.737C401.023 221.737 401.31 221.45 401.31 221.097C401.31 220.744 401.023 220.457 400.67 220.457C400.317 220.457 400.03 220.744 400.03 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 221.097C383.39 221.45 383.676 221.737 384.03 221.737C384.383 221.737 384.67 221.45 384.67 221.097C384.67 220.744 384.383 220.457 384.03 220.457C383.676 220.457 383.39 220.744 383.39 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 221.097C366.749 221.45 367.036 221.737 367.389 221.737C367.742 221.737 368.029 221.45 368.029 221.097C368.029 220.744 367.742 220.457 367.389 220.457C367.036 220.457 366.749 220.744 366.749 221.097Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 237.738C516.514 238.091 516.8 238.378 517.154 238.378C517.507 238.378 517.794 238.091 517.794 237.738C517.794 237.384 517.507 237.098 517.154 237.098C516.8 237.098 516.514 237.384 516.514 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 237.738C499.873 238.091 500.16 238.378 500.513 238.378C500.867 238.378 501.153 238.091 501.153 237.738C501.153 237.384 500.867 237.098 500.513 237.098C500.16 237.098 499.873 237.384 499.873 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 237.738C483.233 238.091 483.519 238.378 483.873 238.378C484.226 238.378 484.513 238.091 484.513 237.738C484.513 237.384 484.226 237.098 483.873 237.098C483.519 237.098 483.233 237.384 483.233 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 237.738C466.592 238.091 466.879 238.378 467.232 238.378C467.586 238.378 467.872 238.091 467.872 237.738C467.872 237.384 467.586 237.098 467.232 237.098C466.879 237.098 466.592 237.384 466.592 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 237.738C449.952 238.091 450.238 238.378 450.592 238.378C450.945 238.378 451.232 238.091 451.232 237.738C451.232 237.384 450.945 237.098 450.592 237.098C450.238 237.098 449.952 237.384 449.952 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 237.738C433.311 238.091 433.598 238.378 433.951 238.378C434.304 238.378 434.591 238.091 434.591 237.738C434.591 237.384 434.304 237.098 433.951 237.098C433.598 237.098 433.311 237.384 433.311 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 237.738C416.671 238.091 416.957 238.378 417.311 238.378C417.664 238.378 417.951 238.091 417.951 237.738C417.951 237.384 417.664 237.098 417.311 237.098C416.957 237.098 416.671 237.384 416.671 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 237.738C400.03 238.091 400.317 238.378 400.67 238.378C401.023 238.378 401.31 238.091 401.31 237.738C401.31 237.384 401.023 237.098 400.67 237.098C400.317 237.098 400.03 237.384 400.03 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 237.738C383.39 238.091 383.676 238.378 384.03 238.378C384.383 238.378 384.67 238.091 384.67 237.738C384.67 237.384 384.383 237.098 384.03 237.098C383.676 237.098 383.39 237.384 383.39 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 237.738C366.749 238.091 367.036 238.378 367.389 238.378C367.742 238.378 368.029 238.091 368.029 237.738C368.029 237.384 367.742 237.098 367.389 237.098C367.036 237.098 366.749 237.384 366.749 237.738Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.514 254.378C516.514 254.732 516.8 255.018 517.154 255.018C517.507 255.018 517.794 254.732 517.794 254.378C517.794 254.025 517.507 253.738 517.154 253.738C516.8 253.738 516.514 254.025 516.514 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.873 254.378C499.873 254.732 500.16 255.018 500.513 255.018C500.867 255.018 501.153 254.732 501.153 254.378C501.153 254.025 500.867 253.738 500.513 253.738C500.16 253.738 499.873 254.025 499.873 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.233 254.378C483.233 254.732 483.519 255.018 483.873 255.018C484.226 255.018 484.513 254.732 484.513 254.378C484.513 254.025 484.226 253.738 483.873 253.738C483.519 253.738 483.233 254.025 483.233 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.592 254.378C466.592 254.732 466.879 255.018 467.232 255.018C467.586 255.018 467.872 254.732 467.872 254.378C467.872 254.025 467.586 253.738 467.232 253.738C466.879 253.738 466.592 254.025 466.592 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.952 254.378C449.952 254.732 450.238 255.018 450.592 255.018C450.945 255.018 451.232 254.732 451.232 254.378C451.232 254.025 450.945 253.738 450.592 253.738C450.238 253.738 449.952 254.025 449.952 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.311 254.378C433.311 254.732 433.598 255.018 433.951 255.018C434.304 255.018 434.591 254.732 434.591 254.378C434.591 254.025 434.304 253.738 433.951 253.738C433.598 253.738 433.311 254.025 433.311 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.671 254.378C416.671 254.732 416.957 255.018 417.311 255.018C417.664 255.018 417.951 254.732 417.951 254.378C417.951 254.025 417.664 253.738 417.311 253.738C416.957 253.738 416.671 254.025 416.671 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.03 254.378C400.03 254.732 400.317 255.018 400.67 255.018C401.023 255.018 401.31 254.732 401.31 254.378C401.31 254.025 401.023 253.738 400.67 253.738C400.317 253.738 400.03 254.025 400.03 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39 254.378C383.39 254.732 383.676 255.018 384.03 255.018C384.383 255.018 384.67 254.732 384.67 254.378C384.67 254.025 384.383 253.738 384.03 253.738C383.676 253.738 383.39 254.025 383.39 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.749 254.378C366.749 254.732 367.036 255.018 367.389 255.018C367.742 255.018 368.029 254.732 368.029 254.378C368.029 254.025 367.742 253.738 367.389 253.738C367.036 253.738 366.749 254.025 366.749 254.378Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_664_32828)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_diii_664_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.282 66.1313H267.476C261.82 66.1313 257.235 70.7161 257.235 76.3717V587.108C257.235 592.763 261.82 597.348 267.476 597.348H472.282C477.938 597.348 482.523 592.763 482.523 587.108V76.3717C482.523 70.7161 477.938 66.1313 472.282 66.1313Z",
    fill: "url(#paint0_linear_664_32828)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.478 224.056H287.956C285.129 224.056 282.836 225.677 282.836 227.676C282.836 229.676 285.129 231.296 287.956 231.296H331.478C334.306 231.296 336.598 229.676 336.598 227.676C336.598 225.677 334.306 224.056 331.478 224.056Z",
    fill: "#74799C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.28 226.977C411.28 221.454 415.757 216.977 421.28 216.977H455.042C460.565 216.977 465.042 221.454 465.042 226.977C465.042 232.5 460.565 236.977 455.042 236.977H421.28C415.757 236.977 411.28 232.5 411.28 226.977Z",
    fill: "#C4E8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.28 218.852C420.673 218.852 419.102 219.329 417.766 220.221C416.43 221.114 415.389 222.383 414.774 223.868C414.159 225.352 413.998 226.986 414.311 228.562C414.625 230.138 415.399 231.586 416.535 232.722C417.671 233.859 419.119 234.632 420.695 234.946C422.271 235.259 423.905 235.099 425.39 234.484C426.874 233.869 428.143 232.827 429.036 231.491C429.929 230.155 430.405 228.584 430.405 226.977C430.403 224.823 429.546 222.758 428.023 221.234C426.5 219.711 424.434 218.854 422.28 218.852ZM425.847 225.544L421.472 229.919C421.414 229.977 421.345 230.023 421.27 230.055C421.194 230.086 421.112 230.103 421.03 230.103C420.948 230.103 420.867 230.086 420.791 230.055C420.715 230.023 420.646 229.977 420.588 229.919L418.713 228.044C418.596 227.927 418.53 227.768 418.53 227.602C418.53 227.436 418.596 227.277 418.713 227.16C418.83 227.043 418.989 226.977 419.155 226.977C419.321 226.977 419.48 227.043 419.597 227.16L421.03 228.593L424.963 224.66C425.021 224.602 425.09 224.556 425.166 224.524C425.242 224.493 425.323 224.477 425.405 224.477C425.487 224.477 425.569 224.493 425.645 224.524C425.72 224.556 425.789 224.602 425.847 224.66C425.906 224.718 425.952 224.787 425.983 224.863C426.014 224.939 426.031 225.02 426.031 225.102C426.031 225.184 426.014 225.265 425.983 225.341C425.952 225.417 425.906 225.486 425.847 225.544Z",
    fill: "#5BB98B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.28,
    y: 224.977,
    width: 28,
    height: 4,
    rx: 2,
    fill: "#5BB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.243 237.697H284.738C283.688 237.697 282.836 238.27 282.836 238.977C282.836 239.684 283.688 240.257 284.738 240.257H391.243C392.293 240.257 393.145 239.684 393.145 238.977C393.145 238.27 392.293 237.697 391.243 237.697Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.799 253.896H284.116C283.409 253.896 282.836 254.469 282.836 255.176C282.836 255.882 283.409 256.456 284.116 256.456H355.799C356.505 256.456 357.079 255.882 357.079 255.176C357.079 254.469 356.505 253.896 355.799 253.896Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.758 244.097H284.116C283.409 244.097 282.836 244.67 282.836 245.377C282.836 246.084 283.409 246.657 284.116 246.657H332.758C333.465 246.657 334.038 246.084 334.038 245.377C334.038 244.67 333.465 244.097 332.758 244.097Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.476 244.097H340.516C340.051 244.097 339.675 244.67 339.675 245.377C339.675 246.084 340.051 246.657 340.516 246.657H372.476C372.941 246.657 373.318 246.084 373.318 245.377C373.318 244.67 372.941 244.097 372.476 244.097Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.758 260.295H284.116C283.409 260.295 282.836 260.869 282.836 261.575C282.836 262.282 283.409 262.855 284.116 262.855H332.758C333.465 262.855 334.038 262.282 334.038 261.575C334.038 260.869 333.465 260.295 332.758 260.295Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.197 101.972H280.036C277.208 101.972 274.916 104.265 274.916 107.093V208.294C274.916 211.122 277.208 213.414 280.036 213.414H418.197C421.024 213.414 423.317 211.122 423.317 208.294V107.093C423.317 104.265 421.024 101.972 418.197 101.972Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.922 101.972H431.761C428.933 101.972 426.641 104.265 426.641 107.093V150.775C426.641 153.603 428.933 155.895 431.761 155.895H459.922C462.749 155.895 465.042 153.603 465.042 150.775V107.093C465.042 104.265 462.749 101.972 459.922 101.972Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.922 159.693H431.761C428.933 159.693 426.641 161.986 426.641 164.814V208.496C426.641 211.324 428.933 213.616 431.761 213.616H459.922C462.749 213.616 465.042 211.324 465.042 208.496V164.814C465.042 161.986 462.749 159.693 459.922 159.693Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_664_32828)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.916,
    y: 72.0007,
    width: 20.7223,
    height: 20.7223,
    rx: 10.3612,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_664_32828)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_664_32828)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_664_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.168 80.2213C287.168 80.0126 286.999 79.8435 286.79 79.8435C286.581 79.8435 286.412 80.0126 286.412 80.2213C286.412 81.4431 286.142 82.2366 285.648 82.7309C285.154 83.2252 284.36 83.4951 283.138 83.4951C282.93 83.4951 282.761 83.6642 282.761 83.8729C282.761 84.0815 282.93 84.2506 283.138 84.2506C284.36 84.2506 285.154 84.5205 285.648 85.0148C286.142 85.5091 286.412 86.3026 286.412 87.5245C286.412 87.7331 286.581 87.9022 286.79 87.9022C286.999 87.9022 287.168 87.7331 287.168 87.5245C287.168 86.3026 287.438 85.5091 287.932 85.0148C288.426 84.5205 289.22 84.2506 290.442 84.2506C290.65 84.2506 290.819 84.0815 290.819 83.8729C290.819 83.6642 290.65 83.4951 290.442 83.4951C289.22 83.4951 288.426 83.2252 287.932 82.7309C287.438 82.2366 287.168 81.4431 287.168 80.2213Z",
    fill: "url(#paint1_linear_664_32828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.887 77.199C282.887 76.9904 282.718 76.8213 282.509 76.8213C282.3 76.8213 282.131 76.9904 282.131 77.199C282.131 77.9836 281.957 78.4623 281.669 78.7512C281.38 79.04 280.901 79.2137 280.117 79.2137C279.908 79.2137 279.739 79.3828 279.739 79.5915C279.739 79.8001 279.908 79.9692 280.117 79.9692C280.901 79.9692 281.38 80.1429 281.669 80.4318C281.957 80.7206 282.131 81.1993 282.131 81.9839C282.131 82.1925 282.3 82.3616 282.509 82.3616C282.718 82.3616 282.887 82.1925 282.887 81.9839C282.887 81.1993 283.06 80.7206 283.349 80.4318C283.638 80.1429 284.117 79.9692 284.901 79.9692C285.11 79.9692 285.279 79.8001 285.279 79.5915C285.279 79.3828 285.11 79.2137 284.901 79.2137C284.117 79.2137 283.638 79.04 283.349 78.7512C283.06 78.4623 282.887 77.9836 282.887 77.199Z",
    fill: "url(#paint2_linear_664_32828)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M318.788 77.2798H302.183C301.266 77.2798 300.523 78.0232 300.523 78.9402C300.523 79.8573 301.266 80.6007 302.183 80.6007H318.788C319.705 80.6007 320.448 79.8573 320.448 78.9402C320.448 78.0232 319.705 77.2798 318.788 77.2798Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.052 84.1235H302.183C301.266 84.1235 300.523 84.8669 300.523 85.784C300.523 86.701 301.266 87.4444 302.183 87.4444H337.052C337.969 87.4444 338.713 86.701 338.713 85.784C338.713 84.8669 337.969 84.1235 337.052 84.1235Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_664_32828)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_diii_664_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.282 66.1313H67.4757C61.8201 66.1313 57.2354 70.7161 57.2354 76.3717V587.108C57.2354 592.763 61.8201 597.348 67.4757 597.348H272.282C277.938 597.348 282.523 592.763 282.523 587.108V76.3717C282.523 70.7161 277.938 66.1313 272.282 66.1313Z",
    fill: "url(#paint3_linear_664_32828)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.478 224.056H87.9563C85.1286 224.056 82.8362 225.677 82.8362 227.676C82.8362 229.676 85.1286 231.296 87.9563 231.296H131.478C134.306 231.296 136.598 229.676 136.598 227.676C136.598 225.677 134.306 224.056 131.478 224.056Z",
    fill: "#74799C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.28 226.977C211.28 221.454 215.757 216.977 221.28 216.977H255.042C260.565 216.977 265.042 221.454 265.042 226.977C265.042 232.5 260.565 236.977 255.042 236.977H221.28C215.757 236.977 211.28 232.5 211.28 226.977Z",
    fill: "#C4E8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.28 218.852C220.673 218.852 219.102 219.329 217.766 220.221C216.43 221.114 215.389 222.383 214.774 223.868C214.159 225.352 213.998 226.986 214.311 228.562C214.625 230.138 215.399 231.586 216.535 232.722C217.671 233.859 219.119 234.632 220.695 234.946C222.271 235.259 223.905 235.099 225.39 234.484C226.874 233.869 228.143 232.827 229.036 231.491C229.929 230.155 230.405 228.584 230.405 226.977C230.403 224.823 229.546 222.758 228.023 221.234C226.5 219.711 224.434 218.854 222.28 218.852ZM225.847 225.544L221.472 229.919C221.414 229.977 221.345 230.023 221.27 230.055C221.194 230.086 221.112 230.103 221.03 230.103C220.948 230.103 220.867 230.086 220.791 230.055C220.715 230.023 220.646 229.977 220.588 229.919L218.713 228.044C218.596 227.927 218.53 227.768 218.53 227.602C218.53 227.436 218.596 227.277 218.713 227.16C218.83 227.043 218.989 226.977 219.155 226.977C219.321 226.977 219.48 227.043 219.597 227.16L221.03 228.593L224.963 224.66C225.021 224.602 225.09 224.556 225.166 224.524C225.242 224.493 225.323 224.477 225.405 224.477C225.487 224.477 225.569 224.493 225.645 224.524C225.72 224.556 225.789 224.602 225.847 224.66C225.906 224.718 225.952 224.787 225.983 224.863C226.014 224.939 226.031 225.02 226.031 225.102C226.031 225.184 226.014 225.265 225.983 225.341C225.952 225.417 225.906 225.486 225.847 225.544Z",
    fill: "#5BB98B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.28,
    y: 224.977,
    width: 28,
    height: 4,
    rx: 2,
    fill: "#5BB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.243 237.697H84.7381C83.6877 237.697 82.8362 238.27 82.8362 238.977C82.8362 239.684 83.6877 240.257 84.7381 240.257H191.243C192.293 240.257 193.145 239.684 193.145 238.977C193.145 238.27 192.293 237.697 191.243 237.697Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.799 253.896H84.1162C83.4093 253.896 82.8362 254.469 82.8362 255.176C82.8362 255.882 83.4093 256.456 84.1162 256.456H155.799C156.505 256.456 157.079 255.882 157.079 255.176C157.079 254.469 156.505 253.896 155.799 253.896Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.758 244.097H84.1162C83.4093 244.097 82.8362 244.67 82.8362 245.377C82.8362 246.084 83.4093 246.657 84.1162 246.657H132.758C133.465 246.657 134.038 246.084 134.038 245.377C134.038 244.67 133.465 244.097 132.758 244.097Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.476 244.097H140.516C140.051 244.097 139.675 244.67 139.675 245.377C139.675 246.084 140.051 246.657 140.516 246.657H172.476C172.941 246.657 173.318 246.084 173.318 245.377C173.318 244.67 172.941 244.097 172.476 244.097Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.758 260.295H84.1162C83.4093 260.295 82.8362 260.869 82.8362 261.575C82.8362 262.282 83.4093 262.855 84.1162 262.855H132.758C133.465 262.855 134.038 262.282 134.038 261.575C134.038 260.869 133.465 260.295 132.758 260.295Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.197 101.972H80.0357C77.2079 101.972 74.9155 104.265 74.9155 107.093V208.294C74.9155 211.122 77.2079 213.414 80.0357 213.414H218.197C221.024 213.414 223.317 211.122 223.317 208.294V107.093C223.317 104.265 221.024 101.972 218.197 101.972Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.922 101.972H231.761C228.933 101.972 226.641 104.265 226.641 107.093V150.775C226.641 153.603 228.933 155.895 231.761 155.895H259.922C262.749 155.895 265.042 153.603 265.042 150.775V107.093C265.042 104.265 262.749 101.972 259.922 101.972Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.922 159.693H231.761C228.933 159.693 226.641 161.986 226.641 164.814V208.496C226.641 211.324 228.933 213.616 231.761 213.616H259.922C262.749 213.616 265.042 211.324 265.042 208.496V164.814C265.042 161.986 262.749 159.693 259.922 159.693Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_664_32828)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.9155,
    y: 72.0007,
    width: 20.7223,
    height: 20.7223,
    rx: 10.3612,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_664_32828)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_664_32828)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_664_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1678 80.2213C87.1678 80.0126 86.9987 79.8435 86.7901 79.8435C86.5815 79.8435 86.4123 80.0126 86.4123 80.2213C86.4123 81.4431 86.1424 82.2366 85.6481 82.7309C85.1538 83.2252 84.3603 83.4951 83.1385 83.4951C82.9299 83.4951 82.7607 83.6642 82.7607 83.8729C82.7607 84.0815 82.9299 84.2506 83.1385 84.2506C84.3603 84.2506 85.1538 84.5205 85.6481 85.0148C86.1424 85.5091 86.4123 86.3026 86.4123 87.5245C86.4123 87.7331 86.5815 87.9022 86.7901 87.9022C86.9987 87.9022 87.1678 87.7331 87.1678 87.5245C87.1678 86.3026 87.4378 85.5091 87.9321 85.0148C88.4264 84.5205 89.2199 84.2506 90.4416 84.2506C90.6503 84.2506 90.8194 84.0815 90.8194 83.8729C90.8194 83.6642 90.6503 83.4951 90.4416 83.4951C89.2199 83.4951 88.4264 83.2252 87.9321 82.7309C87.4378 82.2366 87.1678 81.4431 87.1678 80.2213Z",
    fill: "url(#paint4_linear_664_32828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8867 77.199C82.8867 76.9904 82.7176 76.8213 82.5089 76.8213C82.3003 76.8213 82.1312 76.9904 82.1312 77.199C82.1312 77.9836 81.9575 78.4623 81.6686 78.7512C81.3798 79.04 80.9011 79.2137 80.1165 79.2137C79.9079 79.2137 79.7388 79.3828 79.7388 79.5915C79.7388 79.8001 79.9079 79.9692 80.1165 79.9692C80.9011 79.9692 81.3798 80.1429 81.6686 80.4318C81.9575 80.7206 82.1312 81.1993 82.1312 81.9839C82.1312 82.1925 82.3003 82.3616 82.5089 82.3616C82.7176 82.3616 82.8867 82.1925 82.8867 81.9839C82.8867 81.1993 83.0604 80.7206 83.3492 80.4318C83.6381 80.1429 84.1168 79.9692 84.9014 79.9692C85.11 79.9692 85.2791 79.8001 85.2791 79.5915C85.2791 79.3828 85.11 79.2137 84.9014 79.2137C84.1168 79.2137 83.6381 79.04 83.3492 78.7512C83.0604 78.4623 82.8867 77.9836 82.8867 77.199Z",
    fill: "url(#paint5_linear_664_32828)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M118.788 77.2798H102.183C101.266 77.2798 100.523 78.0232 100.523 78.9402C100.523 79.8573 101.266 80.6007 102.183 80.6007H118.788C119.705 80.6007 120.448 79.8573 120.448 78.9402C120.448 78.0232 119.705 77.2798 118.788 77.2798Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.052 84.1235H102.183C101.266 84.1235 100.523 84.8669 100.523 85.784C100.523 86.701 101.266 87.4444 102.183 87.4444H137.052C137.969 87.4444 138.713 86.701 138.713 85.784C138.713 84.8669 137.969 84.1235 137.052 84.1235Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_664_32828)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_diii_664_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.282 36.1313H167.476C161.82 36.1313 157.235 40.7161 157.235 46.3717V557.108C157.235 562.763 161.82 567.348 167.476 567.348H372.282C377.938 567.348 382.523 562.763 382.523 557.108V46.3717C382.523 40.7161 377.938 36.1313 372.282 36.1313Z",
    fill: "url(#paint6_linear_664_32828)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.478 194.056H187.956C185.129 194.056 182.836 195.677 182.836 197.676C182.836 199.676 185.129 201.296 187.956 201.296H231.478C234.306 201.296 236.598 199.676 236.598 197.676C236.598 195.677 234.306 194.056 231.478 194.056Z",
    fill: "#74799C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.28 196.977C311.28 191.454 315.757 186.977 321.28 186.977H355.042C360.565 186.977 365.042 191.454 365.042 196.977C365.042 202.5 360.565 206.977 355.042 206.977H321.28C315.757 206.977 311.28 202.5 311.28 196.977Z",
    fill: "#C4E8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.28 188.852C320.673 188.852 319.102 189.329 317.766 190.221C316.43 191.114 315.389 192.383 314.774 193.868C314.159 195.352 313.998 196.986 314.311 198.562C314.625 200.138 315.399 201.586 316.535 202.722C317.671 203.859 319.119 204.632 320.695 204.946C322.271 205.259 323.905 205.099 325.39 204.484C326.874 203.869 328.143 202.827 329.036 201.491C329.929 200.155 330.405 198.584 330.405 196.977C330.403 194.823 329.546 192.758 328.023 191.234C326.5 189.711 324.434 188.854 322.28 188.852ZM325.847 195.544L321.472 199.919C321.414 199.977 321.345 200.023 321.27 200.055C321.194 200.086 321.112 200.103 321.03 200.103C320.948 200.103 320.867 200.086 320.791 200.055C320.715 200.023 320.646 199.977 320.588 199.919L318.713 198.044C318.596 197.927 318.53 197.768 318.53 197.602C318.53 197.436 318.596 197.277 318.713 197.16C318.83 197.043 318.989 196.977 319.155 196.977C319.321 196.977 319.48 197.043 319.597 197.16L321.03 198.593L324.963 194.66C325.021 194.602 325.09 194.556 325.166 194.524C325.242 194.493 325.323 194.477 325.405 194.477C325.487 194.477 325.569 194.493 325.645 194.524C325.72 194.556 325.789 194.602 325.847 194.66C325.906 194.718 325.952 194.787 325.983 194.863C326.014 194.939 326.031 195.02 326.031 195.102C326.031 195.184 326.014 195.265 325.983 195.341C325.952 195.417 325.906 195.486 325.847 195.544Z",
    fill: "#5BB98B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.28,
    y: 194.977,
    width: 28,
    height: 4,
    rx: 2,
    fill: "#5BB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.243 207.697H184.738C183.688 207.697 182.836 208.27 182.836 208.977C182.836 209.684 183.688 210.257 184.738 210.257H291.243C292.293 210.257 293.145 209.684 293.145 208.977C293.145 208.27 292.293 207.697 291.243 207.697Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.799 223.895H184.116C183.409 223.895 182.836 224.468 182.836 225.175C182.836 225.882 183.409 226.455 184.116 226.455H255.799C256.505 226.455 257.079 225.882 257.079 225.175C257.079 224.468 256.505 223.895 255.799 223.895Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.758 214.097H184.116C183.409 214.097 182.836 214.67 182.836 215.377C182.836 216.084 183.409 216.657 184.116 216.657H232.758C233.465 216.657 234.038 216.084 234.038 215.377C234.038 214.67 233.465 214.097 232.758 214.097Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.476 214.097H240.516C240.051 214.097 239.675 214.67 239.675 215.377C239.675 216.084 240.051 216.657 240.516 216.657H272.476C272.941 216.657 273.318 216.084 273.318 215.377C273.318 214.67 272.941 214.097 272.476 214.097Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.758 230.295H184.116C183.409 230.295 182.836 230.869 182.836 231.575C182.836 232.282 183.409 232.855 184.116 232.855H232.758C233.465 232.855 234.038 232.282 234.038 231.575C234.038 230.869 233.465 230.295 232.758 230.295Z",
    fill: "#22328A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.197 71.9724H180.036C177.208 71.9724 174.916 74.2648 174.916 77.0926V178.294C174.916 181.122 177.208 183.414 180.036 183.414H318.197C321.024 183.414 323.317 181.122 323.317 178.294V77.0926C323.317 74.2648 321.024 71.9724 318.197 71.9724Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.922 71.9724H331.761C328.933 71.9724 326.641 74.2648 326.641 77.0926V120.775C326.641 123.603 328.933 125.895 331.761 125.895H359.922C362.749 125.895 365.042 123.603 365.042 120.775V77.0926C365.042 74.2648 362.749 71.9724 359.922 71.9724Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.922 129.693H331.761C328.933 129.693 326.641 131.986 326.641 134.814V178.496C326.641 181.324 328.933 183.616 331.761 183.616H359.922C362.749 183.616 365.042 181.324 365.042 178.496V134.814C365.042 131.986 362.749 129.693 359.922 129.693Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_664_32828)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.916,
    y: 42.0007,
    width: 20.7223,
    height: 20.7223,
    rx: 10.3612,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_664_32828)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_664_32828)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_664_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.168 50.2213C187.168 50.0126 186.999 49.8435 186.79 49.8435C186.581 49.8435 186.412 50.0126 186.412 50.2213C186.412 51.4431 186.142 52.2366 185.648 52.7309C185.154 53.2252 184.36 53.4951 183.138 53.4951C182.93 53.4951 182.761 53.6642 182.761 53.8729C182.761 54.0815 182.93 54.2506 183.138 54.2506C184.36 54.2506 185.154 54.5205 185.648 55.0148C186.142 55.5091 186.412 56.3026 186.412 57.5245C186.412 57.7331 186.581 57.9022 186.79 57.9022C186.999 57.9022 187.168 57.7331 187.168 57.5245C187.168 56.3026 187.438 55.5091 187.932 55.0148C188.426 54.5205 189.22 54.2506 190.442 54.2506C190.65 54.2506 190.819 54.0815 190.819 53.8729C190.819 53.6642 190.65 53.4951 190.442 53.4951C189.22 53.4951 188.426 53.2252 187.932 52.7309C187.438 52.2366 187.168 51.4431 187.168 50.2213Z",
    fill: "url(#paint7_linear_664_32828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.887 47.199C182.887 46.9904 182.718 46.8213 182.509 46.8213C182.3 46.8213 182.131 46.9904 182.131 47.199C182.131 47.9836 181.957 48.4623 181.669 48.7512C181.38 49.04 180.901 49.2137 180.117 49.2137C179.908 49.2137 179.739 49.3828 179.739 49.5915C179.739 49.8001 179.908 49.9692 180.117 49.9692C180.901 49.9692 181.38 50.1429 181.669 50.4318C181.957 50.7206 182.131 51.1993 182.131 51.9839C182.131 52.1925 182.3 52.3616 182.509 52.3616C182.718 52.3616 182.887 52.1925 182.887 51.9839C182.887 51.1993 183.06 50.7206 183.349 50.4318C183.638 50.1429 184.117 49.9692 184.901 49.9692C185.11 49.9692 185.279 49.8001 185.279 49.5915C185.279 49.3828 185.11 49.2137 184.901 49.2137C184.117 49.2137 183.638 49.04 183.349 48.7512C183.06 48.4623 182.887 47.9836 182.887 47.199Z",
    fill: "url(#paint8_linear_664_32828)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M218.788 47.2798H202.183C201.266 47.2798 200.523 48.0232 200.523 48.9402C200.523 49.8573 201.266 50.6007 202.183 50.6007H218.788C219.705 50.6007 220.448 49.8573 220.448 48.9402C220.448 48.0232 219.705 47.2798 218.788 47.2798Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.052 54.1235H202.183C201.266 54.1235 200.523 54.8669 200.523 55.784C200.523 56.701 201.266 57.4444 202.183 57.4444H237.052C237.969 57.4444 238.713 56.701 238.713 55.784C238.713 54.8669 237.969 54.1235 237.052 54.1235Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_diii_664_32828",
    x: 254.675,
    y: 62.2912,
    width: 230.407,
    height: 538.897,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28004
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28004
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.056512 0 0 0 0 0.0368 0 0 0 0 0.2832 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_664_32828",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.56008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.056512 0 0 0 0 0.0368 0 0 0 0 0.2832 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7.68024
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.32001
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.972549 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_664_32828",
    result: "effect3_innerShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.84012
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92006
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.937255 0 0 0 0 0.952941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_664_32828",
    result: "effect4_innerShadow_664_32828"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_664_32828",
    x: 273.189,
    y: 71.1373,
    width: 24.1761,
    height: 24.1761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.86343,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.86343
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.86343
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_32828",
    result: "effect2_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_32828",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_diii_664_32828",
    x: 54.6753,
    y: 62.2912,
    width: 230.407,
    height: 538.897,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28004
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28004
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.056512 0 0 0 0 0.0368 0 0 0 0 0.2832 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_664_32828",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.56008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.056512 0 0 0 0 0.0368 0 0 0 0 0.2832 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7.68024
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.32001
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.972549 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_664_32828",
    result: "effect3_innerShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.84012
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92006
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.937255 0 0 0 0 0.952941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_664_32828",
    result: "effect4_innerShadow_664_32828"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_664_32828",
    x: 73.1887,
    y: 71.1373,
    width: 24.1761,
    height: 24.1761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.86343,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.86343
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.86343
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_32828",
    result: "effect2_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_32828",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_diii_664_32828",
    x: 154.675,
    y: 32.2912,
    width: 230.407,
    height: 538.897,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28004
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28004
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.056512 0 0 0 0 0.0368 0 0 0 0 0.2832 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_664_32828",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.56008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.056512 0 0 0 0 0.0368 0 0 0 0 0.2832 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7.68024
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.32001
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.972549 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_664_32828",
    result: "effect3_innerShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.84012
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92006
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.937255 0 0 0 0 0.952941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_664_32828",
    result: "effect4_innerShadow_664_32828"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_664_32828",
    x: 173.189,
    y: 41.1373,
    width: 24.1761,
    height: 24.1761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.86343,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.86343
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.86343
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_32828",
    result: "effect2_dropShadow_664_32828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_32828",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_32828",
    x1: 369.879,
    y1: 66.1313,
    x2: 369.879,
    y2: 597.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_664_32828",
    x1: 285.279,
    y1: 76.8215,
    x2: 287.869,
    y2: 90.1327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_664_32828",
    x1: 285.279,
    y1: 76.8213,
    x2: 287.869,
    y2: 90.1325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_664_32828",
    x1: 169.879,
    y1: 66.1313,
    x2: 169.879,
    y2: 597.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_664_32828",
    x1: 85.2791,
    y1: 76.8215,
    x2: 87.8692,
    y2: 90.1327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_664_32828",
    x1: 85.2791,
    y1: 76.8213,
    x2: 87.8693,
    y2: 90.1325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_664_32828",
    x1: 269.879,
    y1: 36.1313,
    x2: 269.879,
    y2: 567.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_664_32828",
    x1: 185.279,
    y1: 46.8215,
    x2: 187.869,
    y2: 60.1327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_664_32828",
    x1: 185.279,
    y1: 46.8213,
    x2: 187.869,
    y2: 60.1325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EDFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317.45,
    height: 217.607,
    fill: "white",
    transform: "translate(30.3438 70.6924)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 317.45,
    height: 217.607,
    fill: "white",
    transform: "translate(200.344 70.6924)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230.407,
    height: 326.41,
    fill: "white",
    transform: "translate(254.675 64.8513)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9515,
    height: 12.088,
    fill: "white",
    transform: "translate(278.801 76.3179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9515,
    height: 12.088,
    fill: "white",
    transform: "translate(278.801 76.3179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9515,
    height: 12.088,
    fill: "white",
    transform: "translate(278.801 76.3179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230.407,
    height: 326.41,
    fill: "white",
    transform: "translate(54.6753 64.8513)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9515,
    height: 12.088,
    fill: "white",
    transform: "translate(78.801 76.3179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9515,
    height: 12.088,
    fill: "white",
    transform: "translate(78.801 76.3179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9515,
    height: 12.088,
    fill: "white",
    transform: "translate(78.801 76.3179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230.407,
    height: 326.41,
    fill: "white",
    transform: "translate(154.675 34.8513)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9515,
    height: 12.088,
    fill: "white",
    transform: "translate(178.801 46.3179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9515,
    height: 12.088,
    fill: "white",
    transform: "translate(178.801 46.3179)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_664_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9515,
    height: 12.088,
    fill: "white",
    transform: "translate(178.801 46.3179)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.d05434613ee8a5248acd5887db16d580.svg";
export { ForwardRef as ReactComponent };